//用户协议和隐私协议
export const prompt_zh = () => {
  let result = {};
  // result = "<div class='prompt-size'>我们非常注重您的个人信息和隐私保护，为了更好的保障您的个人权益，在您使用前，请务必阅读我们的" +
  //   " <span class='color-blue'>《用户协议》</span> 和 <span class='color-blue'>《隐私条款》</span>。" +
  //   "如果您同意此协议，请点击“同意并继续”开始游戏。</div>";
  result.part1 = "我们非常注重您的个人信息和隐私保护，为了更好的保障您的个人权益，在您使用前，请务必阅读我们的";
  result.part2 = "《用户协议》";
  result.part3 = "和";
  result.part4 = "《隐私条款》";
  result.part5 = "如果您同意此协议，请点击“同意并继续”开始游戏。";
  return result;
}

export const prompt_tw = () => {

}

export const prompt_en = () => {

}

export const agreement_zh = () => {
  let result = "";
  result = "<div class='big-title'>魔兔网络科技用户协议</div>";
  result += "<div><span class='small-title'>前言</span><br>" +
    "欢迎您选择享受厦门魔兔网络科技有限公司（以下简称“魔兔网络科技”）提供的“游戏服务！魔兔网络科技将遵循国家对网络游戏管理的相关规定，提倡“保护未成年人健康、创建绿色网游环境”的口号，努力为玩家提供更优质的服务。<br>" +
    "魔兔网络科技建议玩家在申请用户帐号时，请填写真实的姓名及证件号码相关资料，以便更好地体验魔兔网络科技带给您的游戏服务。</div>";
  result += "<div><span class='small-title'>重要須知：</span><br>" +
    "一、用戶在使用魔兔網絡科技提供的遊戲軟件(下文亦稱為“魔兔網絡科技軟件”）及相關服務（“遊戲軟件及相關服務”下文亦稱為“魔兔網絡科技服務”）之前，請仔細閱讀本《魔兔網絡科技使用許可及服務協議》（下文亦稱為“本協議”）中各條款。魔兔網絡科技特別提醒用戶認真閱讀本協議的全部條款，特別是其中免除或者限制魔兔網絡科技責任的條款（該條款通常含有“不負任何責任”、“無義務”、“不保證”詞彙）、限制用戶權利的條款（該條款通常含有“不得”、“不應”、“無權”詞彙）、法律適用和爭議解決條款，這些條款應在中國法律所允許的範圍內最大程度地適用，該類條款通常用紅色字體標示。<br>" +
    "二、如用戶不同意本協議的任何條款，則不得安裝、使用魔兔網絡科技軟件，不得享用魔兔網絡科技服務。用戶一旦點擊“接受”（或其他具有同樣含義的詞）並安裝魔兔網絡科技軟件，或者註冊、開始使用及/或繼續使用魔兔網絡科技服務，即視為用戶同意並已經接受本協議中全部條款。此後您不得以未閱讀/未同意本協議內容或類似理由提出任何形式的抗辯。<br>" +
    "三、用戶有權在接受魔兔網絡科技服務期間，監督魔兔網絡科技及魔兔網絡科技的工作人員是否按照魔兔網絡科技所公佈的標準向用戶提供服務，也可以隨時向魔兔網絡科技提出與魔兔網絡科技的產品和服務有關的意見和建議。<br>" +
    "如果用戶未滿18周歲的，需在監護人的陪同下閱讀本協議，並在取得監護人對用戶享用魔兔網絡科技提供的魔兔網絡科技服務、向魔兔網絡科技支付費用的行為，以及對本協議全部條款的同意之後，方可享用魔兔網絡科技提供的遊戲服務。</div>";
  result += "<div>第一条协议签署方<br>" +
    "本协议在如下双方之间签署：<br>" +
    "1、魔兔网络科技。即魔兔网络科技服务的提供方，厦门魔兔网络科技有限公司及/或其关联公司（本协议中统称“魔兔网络科技”）。魔兔网络科技可能通过自有的网站与平台、合作方的网站与平台向您提供魔兔网络科技服务。<br>" +
    "2、您，又称“玩家”或“用户”。即通过魔兔网络科技提供的合法途径，获得魔兔网络科技非商业使用性质之授权，从而安装、使用魔兔网络科技软件或接受魔兔网络科技服务的自然人。<br>" +
    "第二条定义和说明<br>" +
    "如无相反说明，以下词语具有如下含义：<br>" +
    "1、魔兔网络科技软件：指魔兔网络科技提供的游戏软件（包括任何可在移动智能设备及/或电脑终端上，以客户端/微端或网页形式进行操作的适配版本），以及与该游戏软件相关的更新、升级、补丁、资料片。并可能包括相关的网络服务器、网站（包括但不限于该游戏之官方网站或官方论坛)、电子媒体、印刷材料或电子文档。<br>" +
    "2、魔兔网络科技服务：指魔兔网络科技向您提供的、与前述魔兔网络科技软件相关的各项在线运营服务，并包括魔兔网络科技软件本身。<br>" +
    "3、增值服务代用币：指魔兔网络科技为满足玩家在魔兔网络科技服务中的正常交易交流需求，而设计的一种虚拟兑换工具，通过人民币按游戏不时调整的比例直接或间接购买，可用于换取游戏中指定的各类虚拟物品使用权或增值服务，并仅限于在特定游戏中使用和流通。<br>" +
    "第三条知识产权声明<br>" +
    "1、魔兔网络科技依法享有魔兔网络科技软件的一切合法权益（包括但不限于其中涉及的计算机软件著作权、美术作品著作权和专利权知识产权，运营魔兔网络科技软件的权利），或已从合法权利人处取得合法授权，从而有权为用户提供魔兔网络科技软件及魔兔网络科技服务。<br>" +
    "2、魔兔网络科技服务所体现的“魔兔网络科技”、LOGO（图形），以及在具体服务中使用的用以标识服务名称与来源的文字、LOGO（图形）（包括但不限于魔兔网络科技服务的名称、LOGO、ICON，魔兔网络科技软件开发者的名称、LOGO、ICON），属于魔兔网络科技及/或其关联公司、合作公司在中国及/或其他国家/地区的商标或者注册商标。<br>" +
    "3、魔兔网络科技服务可能涉及第三方知识产权，如该第三方对您在魔兔网络科技服务中使用该知识产权有要求的，魔兔网络科技将以适当方式向您告知该要求，您应当遵守该要求。<br>" +
    "4、本协议未明确授予您的权利均由魔兔网络科技保留。<br>" +
    "第四条魔兔网络科技软件使用许可与限制<br>" +
    "1、在用户同意接受本协议全部条款的前提下，魔兔网络科技同意授予用户非商业使用性质的、可撤销的、可变更的、非专有的、不可转让且不可转授权的使用本魔兔网络科技软件及魔兔网络科技服务的权利。用户可在授权范围内将本魔兔网络科技软件安装在供个人使用的移动智能设备或电脑终端上，并以魔兔网络科技指定的方式运行本魔兔网络科技软件的一份副本并享受魔兔网络科技提供的服务。 魔兔网络科技基于本协议授予用户的许可是针对个人使用的许可。如用户有需要在个人使用的范围以外使用魔兔网络科技软件及魔兔网络科技服务或者将魔兔网络科技软件与魔兔网络科技服务用于任何商业用途，则用户应与魔兔网络科技联系并获得魔兔网络科技另行授权。任何未经魔兔网络科技许可的安装、使用、访问、显示、运行、商业使用行为均属对魔兔网络科技的侵权。<br>" +
    "2、除非本协议另有约定，否则，未经魔兔网络科技事先书面同意，用户不得实施下列行为（无论是营利的还是非营利的）：<br>" +
    "(1)复制、翻录、反编译（de-compile）、反汇编（disassemble）、传播和陈列魔兔网络科技软件的程序、使用手册和其它图文音像资料的全部或部分内容，或对魔兔网络科技软件的任何功能或程序进行反向工程（reverse engineering）。<br>" +
    "(2)公开展示和以各种形式、在各种平台（包括但不限于网络直播平台、网站、APP）播放魔兔网络科技软件/魔兔网络科技服务的全部或部分内容。<br>" +
    "(3)出租、销售魔兔网络科技软件或者利用魔兔网络科技软件从事任何营利行为。<br>" +
    "(4)修改或遮盖魔兔网络科技软件程序、图像、动画、包装和手册内容上的服务名称、公司标志、商标（或）版权信息、其他知识产权声明内容。<br>" +
    "(5)其它违反商标法、著作权法、计算机软件保护条例和相关法律法规、国际条约的行为。<br>" +
    "第五条资费政策<br>" +
    "1、魔兔网络科技有权决定魔兔网络科技软件及魔兔网络科技服务的收费方式和资费标准，魔兔网络科技有权就魔兔网络科技软件和魔兔网络科技服务在不同阶段确定不同的收费方式和资费标准，且魔兔网络科技有权根据需要对资费政策随时进行调整。<br>" +
    "具体收费方式、资费标准，包括但不限于魔兔网络科技软件的收费标准、游戏中虚拟物品的使用权以及增值服务（如有）的具体收费标准，均由魔兔网络科技在APP STORE或其他APP发布渠道、游戏内道具商城、道具购买界面、游戏官网游戏模块上，以网络游戏行业通用的形式颁布。<br>" +
    "用户有义务在选择前仔细阅读，一旦用户选择下载收费的魔兔网络科技软件、购买相关虚拟物品使用权或者接受相关服务，则表明用户已经充分理解并接受相应的收费方式和资费标准。<br>" +
    "2、魔兔网络科技有权根据需要，在游戏中设立、添加、修改增值服务并发行增值服务代用币。<br>" +
    "增值服务代用币通过使用人民币兑换获得，人民币一经兑换成增值服务代用币，则视为人民币已经使用，增值服务代用币不可兑换成人民币；增值服务代用币用于购买相关虚拟物品使用权或者接受相关增值服务。<br>" +
    "在以用户购买虚拟物品的使用权或者以接受其他增值服务作为收费项目的情况下，如超出该虚拟物品的有效使用期限或增值服务的有效服务期限（不管用户是否已经实际使用或者享受服务），或者超出有效使用或服务次数，魔兔网络科技即有权采取措施取消用户对上述虚拟物品的使用权或者停止提供增值服务。<br>" +
    "第六条游戏虚拟物品<br>" +
    "1、游戏虚拟物品（或简称“虚拟物品”）包括但不限于游戏角色、资源、道具（包括但不限于游戏中的武器、外套、宠物、装备），其所有权归魔兔网络科技，用户只能在合乎法律规定的情况下，根据游戏规则在游戏服务器开放期间进行使用。<br>" +
    "2、游戏中各类虚拟物品，如对使用期限无特殊标识的，均默认用户可在获得使用权后持续使用，直至相应魔兔网络科技服务终止；如对使用期限有特殊标识的，则其使用期以特殊标识的期限为准，超过使用期的，魔兔网络科技有权不另行通知用户而随时收回其使用权（该使用期限不因任何原因而中断、中止）。<br>" +
    "第七条用户帐号注册、使用与保管<br>" +
    "1、帐号注册用户承诺以其真实身份注册魔兔网络科技帐号或魔兔网络科技认可的其他合作方帐号，并以该帐号（下亦称“用户帐号”）接受魔兔网络科技。用户同意，以用户提供的真实准确的个人资料作为认定用户与游戏帐号的关联性以及用户身份的唯一证据。<br>" +
    "2、用户帐号使用与保管<br>" +
    "(1)根据必备条款的约定，魔兔网络科技有权审查您注册时所提供的身份信息是否真实、有效，并应积极地采取技术与管理合理措施保障用户帐号的安全、有效；您有义务妥善保管用户帐号及密码，并正确、安全地使用其用户帐号及密码。任何一方未尽上述义务导致用户帐号密码遗失、用户帐号被盗情形而给您或他人的民事权利造成损害的，应当承担由此产生的法律责任。<br>" +
    "(2)您对所持用户帐号产生的行为依法享有权利和承担责任。<br>" +
    "(3)一旦发现用户帐号或密码被他人非法使用或有使用异常的情况的，您应及时根据帐号服务提供方公布的处理方式进行处理，并有权及时通知魔兔网络科技服务提供方魔兔网络科技采取措施暂停该用户帐号的登录和使用。<br>" +
    "(4)魔兔网络科技根据用户的通知采取措施暂停用户帐号的登录和使用的，魔兔网络科技应当要求用户提供并核实与其注册身份信息相一致的个人有效身份信息或证明。<br>" +
    "(5)魔兔网络科技核实用户所提供的个人有效身份信息或证明与所注册的身份信息相一致的，应当及时采取措施暂停用户帐号的登录和使用。<br>" +
    "(6)魔兔网络科技违反前项⑸的约定，未及时采取措施暂停用户帐号的登录和使用，因此而给用户造成损失的，应当承担相应的法律责任。<br>" +
    "(7)用户没有提供其个人有效身份信息或证明，或者用户提供的个人有效身份信息或证明与所注册的身份信息不一致的，魔兔网络科技有权拒绝用户上述请求。<br>" +
    "(8)用户为了维护其合法权益，向魔兔网络科技提供与所注册的身份信息相一致的个人有效身份信息或证明时，魔兔网络科技应当依法为用户提供帐号注册人证明、原始注册信息必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。<br>" +
    "(9)如用户连续365天没有登录游戏，则自连续没有登录游戏的第365天当天的24时起，魔兔网络科技有权采取措施删除该用户帐号以及该用户帐号在游戏数据库中的任何记录（包括但不限于角色、级、虚拟物品、增值服务代用币数据信息），删除后的数据信息无法再恢复。<br>" +
    "3、如果您选择通过“快速游戏”、“游客”或其他类似便捷模式（下称“快速模式”），在未注册用户帐号的前提下快速登录游戏的，请您登录后及时绑定用户帐号；如您未绑定用户帐号，则一旦您卸载、重装魔兔网络科技软件，或您的移动智能设备、电脑损坏导致魔兔网络科技软件无法正常启动的，您在快速模式下的全部游戏数据、充值记录将无法查询、恢复。<br>" +
    "第八条用户信息保护与收集<br>" +
    "1、魔兔网络科技要求用户提供与其个人身份有关的信息资料时，应当事先以明确而易见的方式向用户公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护用户的个人信息资料的安全。 未经用户许可魔兔网络科技不得向任何第三方提供、公开或共享用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址个人身份信息，但下列情况除外：<br>" +
    "(1)用户或用户监护人授权魔兔网络科技披露的；<br>" +
    "(2)有关法律要求魔兔网络科技披露的；<br>" +
    "(3)司法机关或行政机关基于法定程序要求魔兔网络科技提供的；<br>" +
    "(4)魔兔网络科技为了维护自己合法权益而向用户提起诉讼或者仲裁时；<br>" +
    "(5)应用户监护人的合法要求而提供用户个人身份信息时；<br>" +
    "(6)应证券交易所、证券监督管理机构以及具备专业知识及保密义务 的会计师、律师、技术人员的要求时。<br>" +
    "为保障用户的隐私权、规范对用户个人信息的利用，魔兔网络科技制定了《网络游戏用户隐私权保护和个人信息利用政策》，请用户详细阅读该政策的内容。<br>" +
    "2、除前述个人信息资料之外，您同意并授权魔兔网络科技基于行政/司法机关的要求或安全、用户体验优化考虑而收集您的其他必要信息，但魔兔网络科技仅可为履行本协议之目的收集与利用该信息。<br>" +
    "第九条魔兔网络科技的义务<br>" +
    "1、魔兔网络科技同意通过互联网络，根据本协议约定，为用户提供魔兔网络科技服务。<br>" +
    "2、魔兔网络科技保存游戏虚拟货币的充值记录，保存期限为自用户充值之日起180日。<br>" +
    "3、在使用魔兔网络科技游戏虚拟货币的过程中，用户有权向魔兔网络科技要求协助调取游戏虚拟货币充值记录和转移记录，魔兔网络科技应当要求用户提供并核实与其注册身份信息相一致的个人有效身份信息或证明，魔兔网络科技核实用户所提供的个人有效身份信息或证明与所注册的身份信息相一致的，应当予以协助提供。用户没有提供其个人有效身份信息或证明，或者用户提供的个人有效身份信息或证明与所注册的身份信息不一致的，魔兔网络科技有权拒绝用户前述请求。<br>" +
    "第十条用户的义务<br>" +
    "1、用户应自行配备上网的所需设备，包括但不限于移动智能设备(包括但不限于手机、平板电脑)、电脑、无线路由器或其他必备上网装置。<br>" +
    "2、用户自行负担上网所支付的与此服务相关的电信费用、网络使用费用。<br>" +
    "3、遵守本协议的约定、其他相关规则和制度的规定(包括但不限于用户点击同意的魔兔网络科技邮箱帐号服务条款，以及魔兔网络科技在游戏官方网站或游戏内公布的规则)；遵守中华人民共和国相关法律法规(如果用户是中华人民共和国境外的使用者，还应遵守所属国家或地区的法律法规)。<br>" +
    "第十一条不正当游戏行为<br>" +
    "(1)反对中华人民共和国宪法所确定的基本原则的；<br>" +
    "(2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>" +
    "(3)损害国家荣誉和利益的；<br>" +
    "(4)煽动民族仇恨、民族歧视，破坏民族团结的；<br>" +
    "(5)破坏国家宗教政策，宣扬邪教和封建迷信的；<br>" +
    "(6)散布谣言，扰乱社会秩序，破坏社会稳定的；<br>" +
    "(7)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>" +
    "(8)侮辱或者诽谤他人，侵害他人合法权益的；<br>" +
    "(9)宣扬、教唆使用外挂、私服以及木马的相关内容的；<br>" +
    "(10)发布任何经魔兔网络科技合理判断为不妥当或者魔兔网络科技未认可的软件、文件在内的主页地址或者链接的；<br>" +
    "(11)含有中华人民共和国法律、行政法规禁止的其他内容的。<br>" +
    "2、用户不得通过不正当的手段或其他不公平的手段使用魔兔网络科技软件、魔兔网络科技服务或参与魔兔网络科技活动。<br>" +
    "用户不得干扰魔兔网络科技正常地提供软件和服务，包括但不限于：攻击、侵入魔兔网络科技的网站服务器，或集中时间段内以超出正常用户登录需求的高频率登录或尝试登录服务器从而使网站服务器过载；破解、修改魔兔网络科技提供的魔兔网络科技软件程序；攻击、侵入魔兔网络科技的游戏服务器/游戏服务器端程序或使游戏服务器过载；制作、发布、传播、使用任何形式的妨碍游戏公平性的辅助工具或程序(包括但不限于“外挂”, “外挂”是指独立于游戏软件之外的，能够在游戏运行的同时影响游戏操作的所有程序，包括但不限于模拟用户操作、改变操作环境、修改数据一切类型）。用户不得：利用程序的漏洞和错误(Bug)破坏游戏的正常进行或传播该漏洞或错误(Bug)；不合理地干扰或阻碍他人使用魔兔网络科技所提供的软件和服务；通过异常或者非法的方式使用魔兔网络科技的软件(包括但不限于利用魔兔网络科技软件登录游戏私服)；使用异常的方法登录游戏（包括但不限于使用非魔兔网络科技开发、授权或认可的第三方软件、系统登录游戏）、使用网络加速器外挂软件或机器人程序恶意破坏服务设施、扰乱正常服务秩序的行为；修改、翻译、注释、整理、汇编、演绎魔兔网络科技软件；利用本软件或者线上游戏系统可能存在的技术缺陷或漏洞而以各种形式为自己及他人牟利（包括但不限于复制游戏虚拟物品）或者从事其他不正当行为。<br>" +
    "用户同意以游戏程序中的监测数据作为判断用户是否有通过使用外挂程序方法进行游戏作弊行为的依据。<br>" +
    "第十二条服务的中断、中止、终止<br>" +
    "1、对用户服务的中止与终止<br>" +
    "(1)用户有发布违法信息、严重违背社会公德、以及其他违反法律禁止性规定的行为，魔兔网络科技有权立即终止对用户提供服务。<br>" +
    "(2)用户在接受魔兔网络科技服务时实施不正当行为的，魔兔网络科技有权终止对用户提供服务。该不正当行为的具体情形应当在本协议中有明确约定或属于魔兔网络科技事先明确告知的应被终止服务的禁止性行为，否则，魔兔网络科技不得终止对用户提供服务。<br>" +
    "(3)用户提供虚假注册身份信息，或实施违反本协议的行为，魔兔网络科技有权中止对用户提供全部或部分服务；魔兔网络科技采取中止措施应当通知用户并告知中止期间，中止期间应该是合理的，中止期间届满魔兔网络科技应当及时恢复对用户的服务。<br>" +
    "(4)魔兔网络科技根据本款⑴、⑵、⑶项的约定中止或终止对用户提供部分或全部服务的，魔兔网络科技应负举证责任。<br>" +
    "2、对游戏服务器运营的中断、中止与终止<br>" +
    "(1)为了游戏服务器的正常运行，魔兔网络科技需要定期对游戏服务器进行停机维护或针对突发事件进行紧急停机维护；因上述情况而造成的正常服务中断、中止，请您予以理解，魔兔网络科技则有义务尽力将中断时间限制在最短时间内。<br>" +
    "发生下列情形之一时，魔兔网络科技有权终止或中断游戏服务器所提供之全部或部分服务，对因此而产生的不便或损害，魔兔网络科技对用户或第三人均不承担任何责任：①定期检查或施工，更新软硬件，魔兔网络科技有权暂停服务，但魔兔网络科技会尽快完成维护、更新工作；②游戏服务器遭受损害，无法正常运作；③突发性的软硬件设备与电子通信设备故障；④网络提供商线路或其他故障；⑤在紧急情况之下依照法律的规定或为用户及第三者之人身安全；⑥第三方原因或其他不可抗力的情形。<br>" +
    "魔兔网络科技保留在其认为有必要的情况下，终止或部分终止提供魔兔网络科技服务的权利。<br>" +
    "不管由于何种原因终止魔兔网络科技服务，用户应采取相应的措施自行处理游戏虚拟物品，包括但不限于注销或停止使用用户帐号、游戏虚拟物品相关事宜。用户不得因全面终止魔兔网络科技服务而要求魔兔网络科技承担除用户已经购买但尚未使用的游戏虚拟货币外任何形式的赔偿或补偿责任，包括但不限于因不再能继续使用用户帐号、游戏虚拟物品而要求的赔偿。<br>" +
    "第十三条战斗系统特别说明<br>" +
    "特定魔兔网络科技服务中可能含有战斗系统，在战斗系统里，用户与用户之间可以自由对战。就该类含有战斗系统的魔兔网络科技服务，您一旦点击“接受”（或其他具有同样含义的词）并安装相应的魔兔网络科技软件，或者注册、开始使用及/或继续使用相应的魔兔网络科技软件或魔兔网络科技服务，将视为您同意游戏战斗系统中的所有自由对战行为，并同意遵守自由对战的游戏规则。<br>" +
    "第十四条惩罚的类型与定义<br>" +
    "良好的秩序是一切美好事物的基础。魔兔网络科技在游戏中所作出的一切处罚，均是为了维护游戏世界的和谐与公平。但真正的秩序，应源于每个人的习惯。魔兔网络科技真诚希望能有那样一天——魔兔网络科技不必再用处罚去约束玩家的行为。<br>" +
    "若您违反本协议的规定，除了根据其他条款规定受到相应处罚外，还可能会遭受以下一项或几项惩罚:<br>" +
    "(1)警告：警告仅仅是针对违反游戏规则的玩家做出的教育导向，它是用于正常管理游戏运行的一种方式。<br>" +
    "(2)禁言：关闭违规玩家的部分或全部聊天频道，强制暂停玩家用户帐号的线上对话功能，使玩家用户帐号无法与其他玩家对话，直到此次处罚到期或是取消。<br>" +
    "(3)暂时冻结玩法：将违规玩家的游戏角色进行限制，限制其局部游戏操作，直到此次处罚到期或是取消。<br>" +
    "(4)永久冻结玩法：将违规玩家的游戏角色进行限制，限制其局部游戏操作，且永久不予以解除或释放。<br>" +
    "(5)暂时禁止登录：违规玩家的用户帐号将在一定的时间内暂时无法登录使用魔兔网络科技提供的某个或者某几个游戏，直到此次处罚到期或是取消。<br>" +
    "(6)永久禁止登录：违规玩家的用户帐号将永久无法登录使用魔兔网络科技服务。<br>" +
    "(7)强制离线：强制让违规玩家离开当前游戏，结束玩家当前游戏程序的执行。<br>" +
    "(8)封停账号：暂停或永久停止违规玩家游戏帐号登录魔兔网络科技服务的权利。<br>" +
    "(9)删除档案：将违规玩家在游戏世界中的人物档案删除，不让该人物再出现在游戏世界。<br>" +
    "(10)承担法律责任：玩家的不当行为对他人或者魔兔网络科技造成损害或者与现行法律规定相违背的，违规玩家要依法承担相应的民事、行政或刑事责任。<br>" +
    "(11)解散组织：解散玩家成立的包括但不限于帮派、工会、势力组织。<br>" +
    "(12)修改昵称：对于玩家包括但不限于人物昵称可以由玩家自主命名的昵称或名称进行强制修改。<br>" +
    "(13)暂时限制游戏行为：违规玩家的用户帐号将在一定的时间内被限制使用部分游戏服务。<br>" +
    "(14)撤销交易：撤销违规交易、将交易双方付出的游戏虚拟物品予以还原。<br>" +
    "(15)扣除违规交易所得：扣除违规交易中，违规一方或违规双方所获得的游戏虚拟物品或虚拟货币。<br>" +
    "(16)交易功能限制：暂时冻结违规交易中，违规一方或违规双方所获得的游戏虚拟物品或虚拟货币，并持续考察其在指定期限内的游戏内行为。如指定期限内其无再次违规的，到期自动解冻相应的游戏虚拟物品；如指定期限内其再次违规的，在魔兔网络科技认定其违规行为存在时扣除其被冻结的游戏虚拟物品。<br>" +
    "(17)冻结游戏虚拟物品：对违规玩家限定其游戏角色的游戏虚拟物品的相关功能，包括但不限于物品的使用、交易、给予。<br>" +
    "(18)收回游戏虚拟物品：对于玩家因欺诈或其他违规行为而获取的游戏虚拟物品，包括但不限于游戏虚拟物品进行收回。<br>" +
    "(19)其他处罚措施：包括但不限于没收不正当利益（如玩家通过不正当途径获得的游戏虚拟物品）、倒扣数值（包括但不限于经验值）、删除论坛帖子、屏蔽论坛账号、暂时中断服务。<br>" +
    "第十五条游戏内反骚扰处理规则<br>" +
    "魔兔网络科技倡议玩家对自己的言行负责，文明游戏，健康游戏，若玩家出现本条约定的以下情形，将会被按照本条的规定进行处罚。<br>" +
    "1、冒充系统：在游戏中，凡是通过各种方式、行为冒充系统向其他玩家散布或传播虚假信息，根据情况将有可能受到以下处罚：警告；禁言；暂时冻结玩法；永久冻结玩法；暂时禁止登录；永久禁止登录。<br>" +
    "2、非法网站：为了维护游戏世界中的洁净与和谐，凡是宣扬非法网站的，根据情况将有可能受到以下处罚：警告；禁言；暂时冻结玩法；永久冻结玩法；暂时禁止登录；永久禁止登录。<br>" +
    "3、言行不雅：在游戏中，凡是通过各种方式、行为散布或传播言行不雅的信息，根据情况将有可能受到以下处罚：警告；禁言；暂时冻结玩法；永久冻结玩法；强制离线；暂时禁止登录。<br>" +
    "4、垃圾广告信息：大量传播相同的、类似短语或无实质意义内容的言行，以及任何与所在游戏无关的信息(包括但不限于刷屏)，或者发布、传播任何贬损、诋毁、恶意攻击所在游戏或魔兔网络科技的信息或者其他不实信息，根据情况将有可能受到以下处罚：警告；禁言；暂时冻结玩法；永久冻结玩法；强制离线；暂时禁止登录；永久禁止登录。<br>" +
    "5、地区分裂：在游戏中，凡是通过各种方式或途径引起地区纷争的行为，根据情况将有可能受到以下处罚：警告；禁言；暂时冻结玩法；永久冻结玩法；强制离线；暂时禁止登录；永久禁止登录。<br>" +
    "6、违禁药品或行为：在游戏中，凡是涉及违禁药品的行为，根据情况将有可能受到以下处罚：警告；禁言；暂时冻结玩法；永久冻结玩法；强制离线；暂时禁止登录；永久禁止登录。<br>" +
    "7、现实生活信息和人身恐吓：凡是涉及任何与游戏世界无直接关系的暴力行为，以及泄漏其它玩家或魔兔网络科技员工的任何游戏世界和现实生活信息，根据情况将有可能受到以下处罚：禁言；强制离线；暂时冻结玩法；永久冻结玩法；暂时禁止登录；永久禁止登录；承担法律责任。<br>" +
    "8、宣传或使用木马、外挂、病毒信息：在游戏中，凡是通过各种方式、行为散布或传播、使用木马、外挂、病毒信息，根据情况将有可能受到以下处罚：禁言；暂时冻结玩法；永久冻结玩法；暂时禁止登录；永久禁止登录；强制离线；封停账号；删除档案；承担法律责任。<br>" +
    "9、宣传代练：在游戏中，凡是通过各种方式、行为散布或传播代练的信息，根据情况将有可能受到以下处罚：禁言；暂时冻结玩法；永久冻结玩法；暂时禁止登录；永久禁止登录；强制离线；封停账号；删除档案。<br>" +
    "10、宣传或进行线下交易：用户只可在游戏内或者通过魔兔网络科技认可的交易平台（如有）进行游戏虚拟物品交易。对于用户在任何非魔兔网络科技事先认可的充值平台或其他交易平台进行充值或进行其他交易的相关行为（包括但不限于用户通过第三方进行充值或游戏内虚拟物品的购买），魔兔网络科技将予以严厉打击和处罚。一经查证属实，魔兔网络科技有权视具体情况采取各种处理措施，包括如下一项或几项：警告、倒扣数值、冻结或回收游戏虚拟物品、暂时冻结玩法、永久冻结玩法、强制离线、封停账号、删除档案及采取其他技术措施防止用户从事该行为；情节严重的，魔兔网络科技保留追究用户法律责任的权利。<br>" +
    "11、宣传或发布违法信息，严重违反社会公德：在游戏中，凡是涉及违反国家法律、违背社会道德文明准则的言语或行为，包括但不限于宣传或参与赌博、宣传邪教行为，玩家将受到以下处罚：警告；禁言；强制离线；暂时冻结玩法；永久冻结玩法；暂时禁止登录；永久禁止登录；删除档案；承担法律责任。<br>" +
    "12、其他骚扰行为：除本条上述情形外，若玩家出现其他不符合法律法规、社会公德或游戏规则的骚扰情形，根据情况将可能受到以下处罚：警告；禁言；暂时冻结玩法；永久冻结玩法；暂时禁止登录；永久禁止登录；强制离线；封停账号；删除档案；承担法律责任。<br>" +
    "第十六条游戏管理员(以下简称“GM”)交互管理规则<br>" +
    "1、在游戏过程中，玩家可能会因为种种原因与GM进行交流。魔兔网络科技将就具体游戏提供官方的游戏论坛作为玩家和GM之间的交流平台。如果在游戏中遇到问题，玩家可以通过官方论坛提交问题，它将给玩家提供快速、优质的服务。<br>" +
    "2、希望GM与玩家的交流能对玩家有所帮助，但请玩家遵守相关规定。魔兔网络科技将严肃处理以下行为：<br>" +
    "(1)冒充系统或GM：在游戏中，可能会存在某些玩家冒充系统或GM的行为。如若发现，您可以通过游戏论坛向GM举报，并协助查证。一经查实，魔兔网络科技将对其采取严厉的处罚措施。<br>" +
    "(2)欺骗或试图欺骗GM：在游戏中，玩家不要试图利用魔兔网络科技对您的信任，做出某些欺骗或试图欺骗GM的行为。如若发现，魔兔网络科技将对该玩家采取严厉的处罚措施。试图欺骗GM的行为包括但不限于误导GM、拒绝提供信息、提供虚假信息以及任何试图“诈骗”GM的行为。<br>" +
    "(3)违反或忽视GM做出的提示：在游戏中，为了确保大多数玩家的共同利益，维护正常的游戏秩序，GM可能会提示玩家执行某些操作或停止执行某些操作，任何忽视或阻挠该项工作的行为都可能导致玩家游戏人物受到处罚。因此，玩家应当保持合作态度。<br>" +
    "(4)干扰GM工作：在游戏中，如若出现以下行为，魔兔网络科技将对其采取严厉的处罚措施：<br>" +
    "① 向GM索取任何虚拟游戏物品（包括但不限于游戏资源、装备）；<br>" +
    "② 频繁呼叫GM或发送无实质性内容的请求；<br>" +
    "③ 反复向GM发送已解答或解决问题的帮助请求。<br>" +
    "(5)辱骂或恶意攻击GM：在游戏中，不允许出现辱骂或恶意攻击GM的言行。如若发现，魔兔网络科技将对其采取严厉的处罚措施。<br>" +
    "(6)扰乱游戏秩序<br>" +
    "第十七条命名管理规则<br>" +
    "虽然人物昵称、玩家所建立的组织名称可以由玩家来命名，但是为了维护游戏世界中的洁净与和谐，魔兔网络科技不允许出现包括但不限于涉及种族/宗教、国家政治、国家领导人、淫秽的/粗俗的、诽谤/恐吓、宗教或宗教人物、工作人员、攻击性的、污辱性的、可能引起误会的、违禁药品内容的名称。<br>" +
    "如若发现前述情形，违规玩家根据情况将有可能受到以下处罚：警告；禁言；暂时冻结玩法；永久冻结玩法；强制离线；暂时禁止登录；永久禁止登录；修改昵称；解散组织。<br>" +
    "第十八条利用游戏Bug以及第三方软件处理规则<br>" +
    "1、游戏BUG指游戏系统、程序、设定方面存在的漏洞或不合理的现象。<br>" +
    "玩家有义务向GM报告在游戏中出现的BUG。严禁玩家直接或间接利用游戏BUG、程序漏洞获利或扰乱游戏秩序，或者利用BUG、漏洞以达到个人目的。如果玩家有该行为，一经查实，可能受到如下处罚措施：没收玩家利用BUG进行游戏而直接、间接获得之不正当利益；倒扣数值（包括但不限于经验值）；撤销交易；扣除违规交易所得；交易功能限制；强制离线；暂时冻结玩法；永久冻结玩法；暂时禁止登录；永久禁止登录；删除档案；承担法律责任。<br>" +
    "2、未经许可的第三方软件指可用于在游戏中获取优势，但不属于相应魔兔网络科技软件一部分的任何文件或程序，包括作弊性质的外挂以及相关辅助性质的外挂（包括但不限于自动升级、自动练级、自动吃药、自动完成任务、加速性质、模拟加点、战斗显血或其他超出游戏设定范围的操作）。如若发现使用作弊性质的外挂以及相关辅助性质的外挂，我们将对其采取严厉的处罚措施，包括：没收玩家利用第三方软件进行游戏而直接、间接获得之不正当利益；倒扣数值（包括但不限于经验值）；撤销交易；扣除违规交易所得；交易功能限制；暂时冻结玩法；永久冻结玩法；强制离线；暂时禁止登录；永久禁止登录；删除档案；承担法律责任。<br>" +
    "任何与魔兔网络科技软件同时使用的外部第三方软件可能会对游戏产生不良的影响。使用外部应用程序可能造成的主要后果是数据传送不流畅，导致玩家频繁掉线或卡机。外部应用软件可能使玩家移动智能设备（包括但不限于手机、平板电脑）、电脑感染病毒、间谍软件和其他不明程序的侵扰。第三方软件还可能窃取玩家存储在移动智能设备（包括但不限于手机、平板电脑）、电脑中的信息，账号、密码个人信息。<br>" +
    "第十九条盗号与盗号相关行为处理规则<br>" +
    "为保障玩家能愉悦的体验游戏，保障玩家的正当利益不受到侵害，魔兔网络科技对盗号及盗号相关行为（包括但不限于盗取用户帐号、游戏数据、玩家个人资料、协助盗号者操作及转移游戏虚拟物品行为）将予以严厉打击和处罚。一经查证属实或应有权机关的要求，魔兔网络科技有权视具体情况立即采取暂时限制游戏行为、收回游戏虚拟物品、暂时禁止登录、永久禁止登录、封停账号、删除档案处罚措施，情节严重的，魔兔网络科技保留对涉案玩家追究法律责任的权利。<br>" +
    "尽管您未主动参与盗号，但如您获得的游戏虚拟物品是他人通过盗号方式获得，而后转移或者分配给您的，为了维护被盗玩家的权益及游戏中公平公正的游戏秩序，魔兔网络科技有权收回您购买的该游戏虚拟物品。<br>" +
    "在查证玩家被盗事件的过程中，为能够快速调查、处理问题，魔兔网络科技可能会请相关玩家协助调查，其方式包括但不限于禁止登录调查、线上交流、线下交流。<br>" +
    "第二十条游戏内欺诈行为处理规则<br>" +
    "诚实信用是游戏中的基本原则。游戏中的欺诈行为是指以非法占有为目的，通过虚假承诺、虚构事实、隐瞒真相、故意误导、冒充他人、故意混淆方式，骗取他人的游戏虚拟物品或其它财物。游戏内的欺诈行为包括昵称相似欺诈、冒充好友、冒充官方及其他形式。<br>" +
    "如玩家在游戏内进行欺诈，我们将根据玩家欺诈情节，采取各种处理措施，包括如下一项或几项：收回游戏虚拟物品；倒扣数值（包括但不限于经验值）；暂时冻结玩法；永久冻结玩法；强制离线；暂时禁止登录；永久禁止登录。<br>" +
    "尽管您未主动参与欺诈，但如您获得的游戏虚拟物品是他人通过欺诈方式获得，而后转移或者分配给您的，为了维护被盗玩家的权益及游戏中公平公正的游戏秩序，魔兔网络科技有权收回您购买的该游戏虚拟物品。<br>" +
    "第二十一条与充值相关的不诚信行为处理规则<br>" +
    "诚实信用也是用户在充值相关行为中应遵循的基本原则。用户成功为魔兔网络科技服务充值获得虚拟物品使用权或增值服务（以下统称“充值收益”）后，如对魔兔网络科技服务有任何误会、不满意、建议或其他诉求的，可随时通过客服专区或客服电话通知魔兔网络科技。用户未选择该方式而是另行进行退款操作的，应立即通过客服专区或客服电话通知魔兔网络科技扣除相应的充值收益；如用户进行退款操作后仍占有充值服务的属不诚信行为，魔兔网络科技将予以严厉打击和处罚，包括但不限于如下一项或几项：警告、倒扣数值、冻结或回收游戏虚拟物品、暂时冻结玩法、永久冻结玩法、强制离线、封停账号、删除档案及采取其他技术措施防止用户从事该行为；情节严重的，魔兔网络科技保留追究用户法律责任（包括但不限于民事责任、刑事责任）的权利。<br>" +
    "第二十二条数据异常处理规则<br>" +
    "如果魔兔网络科技发现用户数据异常或者存在违法或者其他不正当行为，“其他不正当行为”包括但不限于：（1）利用bug或非正常游戏方式提升游戏角色数据、游戏内的角色排名的行为；（2）不以正常的游戏娱乐互动需要为目的进行交易；（3）以转移游戏虚拟物品或提升特定游戏角色实力为目的的非正常交易行为，包括但不限于购买并非自身游戏角色游戏所需的游戏虚拟物品、以不正常价格交易游戏虚拟物品、以自己控制的多个游戏账号互相交易游戏虚拟物品。魔兔网络科技有权进行调查并采取相应措施，包括但不限于：(1)删除游戏虚拟物品；(2)没收不正当利益；(3)数据回退或清零；（4）禁言；(5)暂时禁止登录；(6)永久禁止登录；（7）暂时隔离；（8）永久隔离；(9)强制离线；（10)撤销交易；(11)扣除违规交易所得；(12)交易功能限制；(13)封停直至删除用户帐号。用户无权因此要求魔兔网络科技承担任何责任。<br>" +
    "第二十三条牟取不正当利益行为处理规则<br>" +
    "用户理解并同意，魔兔网络科技向用户提供魔兔网络科技服务，是为了让用户体验丰富多彩的游戏内容，而非利用魔兔网络科技服务赚取现实世界的金钱或牟取经济利益。而用户不以体验游戏内容为目的，在游戏中主要进行交易和牟利的行为，会破坏游戏内经济系统的公平性或平衡性，从而对其他用户的游戏体验、游戏本身造成不利影响。<br>" +
    "因此，用户承诺不以营利为目的从事游戏行为或交易虚拟物品，任何以营利为目的从事游戏行为或交易虚拟物品的情形将被视为牟取不正当利益，包括但不限于用户：<br>" +
    "(1)注册多个用户帐号和/或游戏角色ID，以营利为目的进行游戏行为；<br>" +
    "(2)从事游戏内单一或系列产出玩法，将获得的虚拟物品出售获利；<br>" +
    "(3)利用不同服务器的虚拟物品价值差异，在不同服务器买卖虚拟物品获利；<br>" +
    "(4)充当游戏帐号、虚拟物品交易中介收取费用获利；<br>" +
    "(5)在非魔兔网络科技提供或认可的交易平台上交易用户帐号或虚拟物品获利；<br>" +
    "(6)将游戏内获得的虚拟物品用于出售获利而不注重本身角色实力的提升，角色多个技能、修炼、装备、宠物水平与角色级相差较大的；<br>" +
    "(7)利用游戏行为和游戏 内容组织或参与赌博、实施或参与实施盗窃他人财产或虚拟物品涉嫌违法犯罪行为的；<br>" +
    "(8)其他任何不以正常的游戏娱乐互动需要为目的的游戏内牟利行为。<br>" +
    "魔兔网络科技有权对牟取不正当利益的用户同时采取以下措施：对所有参与牟取不正当利益的用户帐号（包括但不限于获得、转移、出售游戏虚拟物品的账号）进行倒扣数值、收回游戏虚拟物品、暂时冻结玩法、永久冻结玩法、强制离线、暂时隔离、永久隔离、封停帐号、撤销交易、扣除违规交易所得、交易功能限制、删除档案及采取其他技术措施防止用户从事该行为；情节严重的，魔兔网络科技保留追究用户法律责任的权利。<br>" +
    "第二十四条角色保护规则<br>" +
    "若您报告角色被盗、遭遇黑客行为或出现其他异常情况，或者魔兔网络科技发现您的角色存在被盗、共享或者被滥用迹象或者其他异常情况，为避免您的游戏角色、游戏虚拟物品遭受不法侵害，魔兔网络科技将会对您的角色进行调查，并根据情节，在调查期间对您的角色采取保护性措施（包括但不限于暂时冻结角色）。请您根据魔兔网络科技的指引，提交相关材料以配合魔兔网络科技的调查，以便尽快解除您角色的保护性措施。<br>" +
    "第二十五条损害赔偿<br>" +
    "如您在游戏内的违规行为给魔兔网络科技或第三方造成损害的，您应承担相应的法律责任，而且针对自身的损害魔兔网络科技有权采取一切合理的行动，包括但不限于收回游戏虚拟物品，魔兔网络科技并有权向您索回损失额并要求您承担魔兔网络科技合理的追索费用。<br>" +
    "第二十六条不可抗力<br>" +
    "魔兔网络科技对不可抗力导致的损失不承担责任。本协议所称不可抗力包括：天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，境内外基础电信运营商的故障、计算机、移动设备或互联网相关技术缺陷、互联网覆盖范围限制、计算机、移动设备病毒、黑客攻击因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况。<br>" +
    "第二十七条链接及广告信息<br>" +
    "魔兔网络科技在游戏官方网站、游戏官方论坛、游戏中所提供的所有链接，可能链接到其他个人、公司或组织的网站，提供该网站的目的，是便利用户自行搜索或取得相关信息，魔兔网络科技对于被链接的个人、公司或组织的网站所提供的产品、服务或信息，不担保其真实性、完整性、实时性或可信度。这些个人、公司或组织与魔兔网络科技间不存在任何雇佣、委任、代理、合伙或其他类似的关系。<br>" +
    "魔兔网络科技在游戏官方网站、游戏官方论坛、游戏内可能刊登商业广告或其他推广活动信息。这些广告或推广活动信息是由广告商或商业服务提供者提供，并承担相应责任，魔兔网络科技仅提供刊登内容的媒介。用户通过该链接的网站或广告所购买的商品或服务，其交易行为仅存在于用户与该商品或服务的提供者之间，与魔兔网络科技无关，魔兔网络科技不就用户与该商品或服务的提供者之间所产生的交易行为承担任何法律责任，用户应予以特别留意。<br>" +
    "第二十八条信息的储存和安全及服务的限制<br>" +
    "魔兔网络科技对本协议下所提供的服务将尽力维护其安全性及方便性，但对服务中出现的信息（包括但不限于用户发布的信息）删除或储存失败不承担任何责任。魔兔网络科技保留判定用户的行为是否符合本协议约定的权利，如果用户违背了本协议的约定，魔兔网络科技有权中断依据本协议对用户提供的服务。<br>" +
    "第二十九条条款变更<br>" +
    "魔兔网络科技有权在必要的时候修改本协议条款，敬请用户定期查询有关内容。用户如继续使用本协议涉及的服务，则视为对修改内容的同意；用户在不同意修改内容的情况下，应当卸载魔兔网络科技软件、终止本协议并停止使用魔兔网络科技服务。<br>" +
    "第三十条游戏数据<br>" +
    "在用户参加游戏过程中产生并储存于魔兔网络科技服务器中的任何数据信息，包括但不限于账号数据信息、角色数据信息、级及虚拟物品数据信息（但用户的姓名、身份证号、电话号码个人身份数据信息除外），属于游戏软件的一部分，由魔兔网络科技所有并进行管理，用户有权在遵守游戏规则的前提下通过正当的途径对属于自身用户帐号的数据信息进行修改、转移、抛弃。<br>" +
    "第三十一条通知<br>" +
    "魔兔网络科技所有发给用户的通知可通过游戏内、游戏官方网站或游戏官方论坛重要页面的公告、电子邮件或常规的电话、易信、信件形式传送。同时，用户在此同意魔兔网络科技可以向其电子邮箱、电话、易信、信件发送商业信息。<br>" +
    "第三十二条用户所提供内容的知识产权及授权<br>" +
    "魔兔网络科技尊重知识产权并注重保护用户享有的各项权利。在魔兔网络科技服务中，您可能需要通过上传、发布各种方式向魔兔网络科技提供内容。在此情况下，您仍然享有此内容的完整知识产权。<br>" +
    "您在此明确同意，您在提供前述内容的同时，不可撤销地授予魔兔网络科技及其关联公司一项全球性的、永久的免费许可，允许魔兔网络科技及其关联公司使用、传播、复制、修改、再许可、翻译、出版、表演及展示此内容，以及使用此内容创作衍生作品。<br>" +
    "第三十三条其他约定<br>" +
    "本协议的订立、履行、解释及争议的解决均适用中华人民共和国法律并排除其他一切冲突法的适用。本协议订立于厦门市思明区。如双方就本协议的内容或其执行发生任何争议（包括但不限于合同或者其他财产性权益纠纷），双方应友好协商解决；协商不成时，双方同意交由厦门市思明区人民法院管辖并处理。<br>" +
    "为避免争议，本协议涉及到的有关数据、有关技术方面的问题，用户同意以魔兔网络科技服务器所储存的数据作为判断标准。魔兔网络科技保证该数据的真实性。<br>" +
    "本协议所有条款的标题仅为方便阅读，本身并无实际涵义，不能作为本协议及相关条款涵义解释的依据。<br>" +
    "如本协议中的任何条款因任何原因被判定为完全或部分无效或不具有执行力的，本协议的其他条款仍应有效并且有执行力。<br>" +
    "魔兔网络科技不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响魔兔网络科技在将来行使该权利。</div>" ;
  result += "<div><span class='small-title'>⊙重要提示</span> <br>" +
  "营造舒适、公平、富有人情味的游戏环境是魔兔网络科技的目的。魔兔网络科技随时敞开心扉接纳不同地域、年龄和文化背景的玩家。在游戏中，不论是魔兔网络科技的工作人员，还是其他数以万计的玩家，都在扮演不同的角色、行使各自的使命。魔兔网络科技对尊重游戏规则和尊重他人的玩家满怀感激和敬意，让我们携手打造绿色网游，共同编织美好梦想！<br>" +
  "青少年用户必须遵守全国青少年网络文明公约：要善于网上学习，不浏览不良信息；要诚实友好交流，不侮辱欺诈他人；要增强自护意识，不随意约会网友；要维护网络安全，不破坏网络秩序；要有益身心健康，不沉溺虚拟时空。</div>";
  return result;
}

export const agreement_tw = () => {
  let result = "";
  result = "<div class='big-title'>魔兔網絡科技用戶協議</div>";
  result += "<div><span class='small-title'>前言</span><br>" +
    "欢迎您选择享受厦门魔兔网络科技有限公司（以下简称“魔兔网络科技”）提供的“游戏服务！魔兔网络科技将遵循国家对网络游戏管理的相关规定，提倡“保护未成年人健康、创建绿色网游环境”的口号，努力为玩家提供更优质的服务。<br>" +
    "魔兔网络科技建议玩家在申请用户帐号时，请填写真实的姓名及证件号码相关资料，以便更好地体验魔兔网络科技带给您的游戏服务。</div>";
  result += "<div><span class='small-title'>重要须知：</span><br>" +
    "一、用户在使用魔兔网络科技提供的游戏软件(下文亦称为“魔兔网络科技软件”）及相关服务（“游戏软件及相关服务”下文亦称为“魔兔网络科技服务”）之前，请仔细阅读本《魔兔网络科技使用许可及服务协议》（下文亦称为“本协议”）中各条款。魔兔网络科技特别提醒用户认真阅读本协议的全部条款，特别是其中免除或者限制魔兔网络科技责任的条款（该条款通常含有“不负任何责任”、“无义务”、“不保证”词汇）、限制用户权利的条款（该条款通常含有“不得”、“不应”、“无权”词汇）、法律适用和争议解决条款，这些条款应在中国法律所允许的范围内最大程度地适用，该类条款通常用红色字体标示。<br>" +
    "二、如用户不同意本协议的任何条款，则不得安装、使用魔兔网络科技软件，不得享用魔兔网络科技服务。用户一旦点击“接受”（或其他具有同样含义的词）并安装魔兔网络科技软件，或者注册、开始使用及/或继续使用魔兔网络科技服务，即视为用户同意并已经接受本协议中全部条款。此后您不得以未阅读/未同意本协议内容或类似理由提出任何形式的抗辩。<br>" +
    "三、用户有权在接受魔兔网络科技服务期间，监督魔兔网络科技及魔兔网络科技的工作人员是否按照魔兔网络科技所公布的标准向用户提供服务，也可以随时向魔兔网络科技提出与魔兔网络科技的产品和服务有关的意见和建议。<br>" +
    "如果用户未满18周岁的，需在监护人的陪同下阅读本协议，并在取得监护人对用户享用魔兔网络科技提供的魔兔网络科技服务、向魔兔网络科技支付费用的行为，以及对本协议全部条款的同意之后，方可享用魔兔网络科技提供的游戏服务。</div>";
  result += "<div>第一條協議簽署方<br>" +
    "本協議在如下雙方之間簽署：<br>" +
    "1、魔兔網絡科技。即魔兔網絡科技服務的提供方，廈門魔兔網絡科技有限公司及/或其關聯公司（本協議中統稱“魔兔網絡科技”）。魔兔網絡科技可能通過自有的網站與平台、合作方的網站與平台向您提供魔兔網絡科技服務。<br>" +
    "2、您，又稱“玩家”或“用戶”。即通過魔兔網絡科技提供的合法途徑，獲得魔兔網絡科技非商業使用性質之授權，從而安裝、使用魔兔網絡科技軟件或接受魔兔網絡科技服務的自然人。<br>" +
    "第二條定義和說明<br>" +
    "如無相反說明，以下詞語具有如下含義：<br>" +
    "1、魔兔網絡科技軟件：指魔兔網絡科技提供的遊戲軟件（包括任何可在移動智能設備及/或電腦終端上，以客戶端/微端或網頁形式進行操作的適配版本），以及與該遊戲軟件相關的更新、升級、補丁、資料片。並可能包括相關的網絡服務器、網站（包括但不限於該遊戲之官方網站或官方論壇)、電子媒體、印刷材料或電子文檔。<br>" +
    "2、魔兔網絡科技服務：指魔兔網絡科技向您提供的、與前述魔兔網絡科技軟件相關的各項在線運營服務，並包括魔兔網絡科技軟件本身。<br>" +
    "3、增值服務代用幣：指魔兔網絡科技為滿足玩家在魔兔網絡科技服務中的正常交易交流需求，而設計的一種虛擬兌換工具，通過人民幣按遊戲不時調整的比例直接或間接購買，可用於換取遊戲中指定的各類虛擬物品使用權或增值服務，並僅限於在特定遊戲中使用和流通。<br>" +
    "第三條知識產權聲明<br>" +
    "1、魔兔網絡科技依法享有魔兔網絡科技軟件的一切合法權益（包括但不限於其中涉及的計算機軟件著作權、美術作品著作權和專利權知識產權，運營魔兔網絡科技軟件的權利），或已從合法權利人處取得合法授權，從而有權為用戶提供魔兔網絡科技軟件及魔兔網絡科技服務。<br>" +
    "2、魔兔網絡科技服務所體現的“魔兔網絡科技”、LOGO（圖形），以及在具體服務中使用的用以標識服務名稱與來源的文字、LOGO（圖形）（包括但不限於魔兔網絡科技服務的名稱、LOGO、ICON，魔兔網絡科技軟件開發者的名稱、LOGO、ICON），屬於魔兔網絡科技及/或其關聯公司、合作公司在中國及/或其他國家/地區的商標或者註冊商標。<br>" +
    "3、魔兔網絡科技服務可能涉及第三方知識產權，如該第三方對您在魔兔網絡科技服務中使用該知識產權有要求的，魔兔網絡科技將以適當方式向您告知該要求，您應當遵守該要求。<br>" +
    "4、本協議未明確授予您的權利均由魔兔網絡科技保留。<br>" +
    "第四條魔兔網絡科技軟件使用許可與限制<br>" +
    "1、在用戶同意接受本協議全部條款的前提下，魔兔網絡科技同意授予用戶非商業使用性質的、可撤銷的、可變更的、非專有的、不可轉讓且不可轉授權的使用本魔兔網絡科技軟件及魔兔網絡科技服務的權利。用戶可在授權範圍內將本魔兔網絡科技軟件安裝在供個人使用的移動智能設備或電腦終端上，並以魔兔網絡科技指定的方式運行本魔兔網絡科技軟件的一份副本並享受魔兔網絡科技提供的服務。魔兔網絡科技基於本協議授予用戶的許可是針對個人使用的許可。如用戶有需要在個人使用的範圍以外使用魔兔網絡科技軟件及魔兔網絡科技服務或者將魔兔網絡科技軟件與魔兔網絡科技服務用於任何商業用途，則用戶應與魔兔網絡科技聯繫並獲得魔兔網絡科技另行授權。任何未經魔兔網絡科技許可的安裝、使用、訪問、顯示、運行、商業使用行為均屬對魔兔網絡科技的侵權。<br>" +
    "2、除非本協議另有約定，否則，未經魔兔網絡科技事先書面同意，用戶不得實施下列行為（無論是營利的還是非營利的）：<br>" +
    "(1)複製、翻錄、反編譯（de-compile）、反彙編（disassemble）、傳播和陳列魔兔網絡科技軟件的程序、使用手冊和其它圖文音像資料的全部或部分內容，或對魔兔網絡科技軟件的任何功能或程序進行反向工程（reverse engineering）。<br>" +
    "(2)公開展示和以各種形式、在各種平台（包括但不限於網絡直播平台、網站、APP）播放魔兔網絡科技軟件/魔兔網絡科技服務的全部或部分內容。<br>" +
    "(3)出租、銷售魔兔網絡科技軟件或者利用魔兔網絡科技軟件從事任何營利行為。<br>" +
    "(4)修改或遮蓋魔兔網絡科技軟件程序、圖像、動畫、包裝和手冊內容上的服務名稱、公司標誌、商標（或）版權信息、其他知識產權聲明內容。<br>" +
    "(5)其它違反商標法、著作權法、計算機軟件保護條例和相關法律法規、國際條約的行為。<br>" +
    "第五條資費政策<br>" +
    "1、魔兔網絡科技有權決定魔兔網絡科技軟件及魔兔網絡科技服務的收費方式和資費標準，魔兔網絡科技有權就魔兔網絡科技軟件和魔兔網絡科技服務在不同階段確定不同的收費方式和資費標準，且魔兔網絡科技有權根據需要對資費政策隨時進行調整。<br>" +
    "具體收費方式、資費標準，包括但不限於魔兔網絡科技軟件的收費標準、遊戲中虛擬物品的使用權以及增值服務（如有）的具體收費標準，均由魔兔網絡科技在APP STORE或其他APP發布渠道、遊戲內道具商城、道具購買界面、遊戲官網游戲模塊上，以網絡遊戲行業通用的形式頒布。<br>" +
    "用戶有義務在選擇前仔細閱讀，一旦用戶選擇下載收費的魔兔網絡科技軟件、購買相關虛擬物品使用權或者接受相關服務，則表明用戶已經充分理解並接受相應的收費方式和資費標準。<br>" +
    "2、魔兔網絡科技有權根據需要，在遊戲中設立、添加、修改增值服務並發行增值服務代用幣。<br>" +
    "增值服務代用幣通過使用人民幣兌換獲得，人民幣一經兌換成增值服務代用幣，則視為人民幣已經使用，增值服務代用幣不可兌換成人民幣；增值服務代用幣用於購買相關虛擬物品使用權或者接受相關增值服務。<br>" +
    "在以用戶購買虛擬物品的使用權或者以接受其他增值服務作為收費項目的情況下，如超出該虛擬物品的有效使用期限或增值服務的有效服務期限（不管用戶是否已經實際使用或者享受服務），或者超出有效使用或服務次數，魔兔網絡科技即有權採取措施取消用戶對上述虛擬物品的使用權或者停止提供增值服務。<br>" +
    "第六條遊戲虛擬物品<br>" +
    "1、遊戲虛擬物品（或簡稱“虛擬物品”）包括但不限於遊戲角色、資源、道具（包括但不限於遊戲中的武器、外套、寵物、裝備），其所有權歸魔兔網絡科技，用戶只能在合乎法律規定的情況下，根據遊戲規則在遊戲服務器開放期間進行使用。<br>" +
    "2、遊戲中各類虛擬物品，如對使用期限無特殊標識的，均默認用戶可在獲得使用權後持續使用，直至相應魔兔網絡科技服務終止；如對使用期限有特殊標識的，則其使用期以特殊標識的期限為準，超過使用期的，魔兔網絡科技有權不另行通知用戶而隨時收回其使用權（該使用期限不因任何原因而中斷、中止）。<br>" +
    "第七條用戶帳號註冊、使用與保管<br>" +
    "1、帳號註冊用戶承諾以其真實身份註冊魔兔網絡科技帳號或魔兔網絡科技認可的其他合作方帳號，並以該帳號（下亦稱“用戶帳號”）接受魔兔網絡科技。用戶同意，以用戶提供的真實準確的個人資料作為認定用戶與遊戲帳號的關聯性以及用戶身份的唯一證據。<br>" +
    "2、用戶帳號使用與保管<br>" +
    "(1)根據必備條款的約定，魔兔網絡科技有權審查您註冊時所提供的身份信息是否真實、有效，並應積極地採取技術與管理合理措施保障用戶帳號的安全、有效；您有義務妥善保管用戶帳號及密碼，並正確、安全地使用其用戶帳號及密碼。任何一方未盡上述義務導致用戶帳號密碼遺失、用戶帳號被盜情形而給您或他人的民事權利造成損害的，應當承擔由此產生的法律責任。<br>" +
    "(2)您對所持用戶帳號產生的行為依法享有權利和承擔責任。<br>" +
    "(3)一旦發現用戶帳號或密碼被他人非法使用或有使用異常的情況的，您應及時根據帳號服務提供方公佈的處理方式進行處理，並有權及時通知魔兔網絡科技服務提供方魔兔網絡科技採取措施暫停該用戶帳號的登錄和使用。<br>" +
    "(4)魔兔網絡科技根據用戶的通知採取措施暫停用戶帳號的登錄和使用的，魔兔網絡科技應當要求用戶提供並核實與其註冊身份信息相一致的個人有效身份信息或證明。<br>" +
    "(5)魔兔網絡科技核實用戶所提供的個人有效身份信息或證明與所註冊的身份信息相一致的，應當及時採取措施暫停用戶帳號的登錄和使用。<br>" +
    "(6)魔兔網絡科技違反前項⑸的約定，未及時採取措施暫停用戶帳號的登錄和使用，因此而給用戶造成損失的，應當承擔相應的法律責任。<br>" +
    "(7)用戶沒有提供其個人有效身份信息或證明，或者用戶提供的個人有效身份信息或證明與所註冊的身份信息不一致的，魔兔網絡科技有權拒絕用戶上述請求。<br>" +
    "(8)用戶為了維護其合法權益，向魔兔網絡科技提供與所註冊的身份信息相一致的個人有效身份信息或證明時，魔兔網絡科技應當依法為用戶提供帳號註冊人證明、原始註冊信息必要的協助和支持，並根據需要向有關行政機關和司法機關提供相關證據信息資料。<br>" +
    "(9)如用戶連續365天沒有登錄遊戲，則自連續沒有登錄遊戲的第365天當天的24時起，魔兔網絡科技有權採取措施刪除該用戶帳號以及該用戶帳號在遊戲數據庫中的任何記錄（包括但不限於角色、級、虛擬物品、增值服務代用幣數據信息），刪除後的數據信息無法再恢復。<br>" +
    "3、如果您選擇通過“快速遊戲”、“遊客”或其他類似便捷模式（下稱“快速模式”），在未註冊用戶帳號的前提下快速登錄遊戲的，請您登錄後及時綁定用戶帳號；如您未綁定用戶帳號，則一旦您卸載、重裝魔兔網絡科技軟件，或您的移動智能設備、電腦損壞導致魔兔網絡科技軟件無法正常啟動的，您在快速模式下的全部遊戲數據、充值記錄將無法查詢、恢復。<br>" +
    "第八條用戶信息保護與收集<br>" +
    "1、魔兔網絡科技要求用戶提供與其個人身份有關的信息資料時，應當事先以明確而易見的方式向用戶公開其隱私權保護政策和個人信息利用政策，並採取必要措施保護用戶的個人信息資料的安全。未經用戶許可魔兔網絡科技不得向任何第三方提供、公開或共享用戶註冊資料中的姓名、個人有效身份證件號碼、聯繫方式、家庭住址個人身份信息，但下列情況除外：<br>" +
    "(1)用戶或用戶監護人授權魔兔網絡科技披露的；<br>" +
    "(2)有關法律要求魔兔網絡科技披露的；<br>" +
    "(3)司法機關或行政機關基於法定程序要求魔兔網絡科技提供的；<br>" +
    "(4)魔兔網絡科技為了維護自己合法權益而向用戶提起訴訟或者仲裁時；<br>" +
    "(5)應用戶監護人的合法要求而提供用戶個人身份信息時；<br>" +
    "(6)應證券交易所、證券監督管理機構以及具備專業知識及保密義務的會計師、律師、技術人員的要求時。<br>" +
    "為保障用戶的隱私權、規範對用戶個人信息的利用，魔兔網絡科技制定了《網絡遊戲用戶隱私權保護和個人信息利用政策》，請用戶詳細閱讀該政策的內容。<br>" +
    "2、除前述個人信息資料之外，您同意並授權魔兔網絡科技基於行政/司法機關的要求或安全、用戶體驗優化考慮而收集您的其他必要信息，但魔兔網絡科技僅可為履行本協議之目的收集與利用該信息。<br>" +
    "第九條魔兔網絡科技的義務<br>" +
    "1、魔兔網絡科技同意通過互聯網絡，根據本協議約定，為用戶提供魔兔網絡科技服務。<br>" +
    "2、魔兔網絡科技保存遊戲虛擬貨幣的充值記錄，保存期限為自用戶充值之日起180日。<br>" +
    "3、在使用魔兔網絡科技遊戲虛擬貨幣的過程中，用戶有權向魔兔網絡科技要求協助調取遊戲虛擬貨幣充值記錄和轉移記錄，魔兔網絡科技應當要求用戶提供並核實與其註冊身份信息相一致的個人有效身份信息或證明，魔兔網絡科技核實用戶所提供的個人有效身份信息或證明與所註冊的身份信息相一致的，應當予以協助提供。用戶沒有提供其個人有效身份信息或證明，或者用戶提供的個人有效身份信息或證明與所註冊的身份信息不一致的，魔兔網絡科技有權拒絕用戶前述請求。<br>" +
    "第十條用戶的義務<br>" +
    "1、用戶應自行配備上網的所需設備，包括但不限於移動智能設備(包括但不限於手機、平板電腦)、電腦、無線路由器或其他必備上網裝置。<br>" +
    "2、用戶自行負擔上網所支付的與此服務相關的電信費用、網絡使用費用。<br>" +
    "3、遵守本協議的約定、其他相關規則和製度的規定(包括但不限於用戶點擊同意的魔兔網絡科技郵箱帳號服務條款，以及魔兔網絡科技在遊戲官方網站或遊戲內公佈的規則)；遵守中華人民共和國相關法律法規(如果用戶是中華人民共和國境外的使用者，還應遵守所屬國家或地區的法律法規)。<br>" +
    "第十一條不正當遊戲行為<br>" +
    "(1)反對中華人民共和國憲法所確定的基本原則的；<br>" +
    "(2)危害國家安全，洩露國家秘密，顛覆國家政權，破壞國家統一的；<br>" +
    "(3)損害國家榮譽和利益的；<br>" +
    "(4)煽動民族仇恨、民族歧視，破壞民族團結的；<br>" +
    "(5)破壞國家宗教政策，宣揚邪教和封建迷信的；<br>" +
    "(6)散佈謠言，擾亂社會秩序，破壞社會穩定的；<br>" +
    "(7)散佈淫穢、色情、賭博、暴力、兇殺、恐怖或者教唆犯罪的；<br>" +
    "(8)侮辱或者誹謗他人，侵害他人合法權益的；<br>" +
    "(9)宣揚、教唆使用外掛、私服以及木馬的相關內容的；<br>" +
    "(10)發布任何經魔兔網絡科技合理判斷為不妥當或者魔兔網絡科技未認可的軟件、文件在內的主頁地址或者鏈接的；<br>" +
    "(11)含有中華人民共和國法律、行政法規禁止的其他內容的。<br>" +
    "2、用戶不得通過不正當的手段或其他不公平的手段使用魔兔網絡科技軟件、魔兔網絡科技服務或參與魔兔網絡科技活動。<br>" +
    "用戶不得乾擾魔兔網絡科技正常地提供軟件和服務，包括但不限於：攻擊、侵入魔兔網絡科技的網站服務器，或集中時間段內以超出正常用戶登錄需求的高頻率登錄或嘗試登錄服務器從而使網站服務器過載；破解、修改魔兔網絡科技提供的魔兔網絡科技軟件程序；攻擊、侵入魔兔網絡科技的遊戲服務器/遊戲服務器端程序或使遊戲服務器過載；製作、發布、傳播、使用任何形式的妨礙遊戲公平性的輔助工具或程序(包括但不限於“外掛”, “外掛”是指獨立於遊戲軟件之外的，能夠在遊戲運行的同時影響遊戲操作的所有程序，包括但不限於模擬用戶操作、改變操作環境、修改數據一切類型）。用戶不得：利用程序的漏洞和錯誤(Bug)破壞遊戲的正常進行或傳播該漏洞或錯誤(Bug)；不合理地干擾或阻礙他人使用魔兔網絡科技所提供的軟件和服務；通過異常或者非法的方式使用魔兔網絡科技的軟件(包括但不限於利用魔兔網絡科技軟件登錄遊戲私服)；使用異常的方法登錄遊戲（包括但不限於使用非魔兔網絡科技開發、授權或認可的第三方軟件、系統登錄遊戲）、使用網絡加速器外掛軟件或機器人程序惡意破壞服務設施、擾亂正常服務秩序的行為；修改、翻譯、註釋、整理、彙編、演繹魔兔網絡科技軟件；利用本軟件或者線上遊戲系統可能存在的技術缺陷或漏洞而以各種形式為自己及他人牟利（包括但不限於復制遊戲虛擬物品）或者從事其他不正當行為。<br>" +
    "用戶同意以遊戲程序中的監測數據作為判斷用戶是否有通過使用外掛程序方法進行遊戲作弊行為的依據。<br>" +
    "第十二條服務的中斷、中止、終止<br>" +
    "1、對用戶服務的中止與終止<br>" +
    "(1)用戶有發布違法信息、嚴重違背社會公德、以及其他違反法律禁止性規定的行為，魔兔網絡科技有權立即終止對用戶提供服務。<br>" +
    "(2)用戶在接受魔兔網絡科技服務時實施不正當行為的，魔兔網絡科技有權終止對用戶提供服務。該不正當行為的具體情形應當在本協議中有明確約定或屬於魔兔網絡科技事先明確告知的應被終止服務的禁止性行為，否則，魔兔網絡科技不得終止對用戶提供服務。<br>" +
    "(3)用戶提供虛假註冊身份信息，或實施違反本協議的行為，魔兔網絡科技有權中止對用戶提供全部或部分服務；魔兔網絡科技採取中止措施應當通知用戶並告知中止期間，中止期間應該是合理的，中止期間屆滿魔兔網絡科技應當及時恢復對用戶的服務。<br>" +
    "(4)魔兔網絡科技根據本款⑴、⑵、⑶項的約定中止或終止對用戶提供部分或全部服務的，魔兔網絡科技應負舉證責任。<br>" +
    "2、對遊戲服務器運營的中斷、中止與終止<br>" +
    "(1)為了遊戲服務器的正常運行，魔兔網絡科技需要定期對遊戲服務器進行停機維護或針對突發事件進行緊急停機​​維護；因上述情況而造成的正常服務中斷、中止，請您予以理解，魔兔網絡科技則有義務盡力將中斷時間限制在最短時間內。<br>" +
    "發生下列情形之一時，魔兔網絡科技有權終止或中斷遊戲服務器所提供之全部或部分服務，對因此而產生的不便或損害，魔兔網絡科技對用戶或第三人均不承擔任何責任：①定期檢查或施工，更新軟硬件，魔兔網絡科技有權暫停服務，但魔兔網絡科技會盡快完成維護、更新工作；②遊戲服務器遭受損害，無法正常運作；③突發性的軟硬件設備與電子通信設備故障；④網絡提供商線路或其他故障；⑤在緊急情況之下依照法律的規定或為用戶及第三者之人身安全；⑥第三方原因或其他不可抗力的情形。<br>" +
    "魔兔網絡科技保留在其認為有必要的情況下，終止或部分終止提供魔兔網絡科技服務的權利。<br>" +
    "不管由於何種原因終止魔兔網絡科技服務，用戶應採取相應的措施自行處理遊戲虛擬物品，包括但不限於註銷或停止使用用戶帳號、遊戲虛擬物品相關事宜。用戶不得因全面終止魔兔網絡科技服務而要求魔兔網絡科技承擔除用戶已經購買但尚未使用的遊戲虛擬貨幣外任何形式的賠償或補償責任，包括但不限於因不再能繼續使用用戶帳號、遊戲虛擬物品而要求的賠償。<br>" +
    "第十三條戰鬥系統特別說明<br>" +
    "特定魔兔網絡科技服務中可能含有戰鬥系統，在戰鬥系統裡，用戶與用戶之間可以自由對戰。就該類含有戰鬥系統的魔兔網絡科技服務，您一旦點擊“接受”（或其他具有同樣含義的詞）並安裝相應的魔兔網絡科技軟件，或者註冊、開始使用及/或繼續使用相應的魔兔網絡科技軟件或魔兔網絡科技服務，將視為您同意遊戲戰鬥系統中的所有自由對戰行為，並同意遵守自由對戰的遊戲規則。<br>" +
    "第十四條懲罰的類型與定義<br>" +
    "良好的秩序是一切美好事物的基礎。魔兔網絡科技在遊戲中所作出的一切處罰，均是為了維護遊戲世界的和諧與公平。但真正的秩序，應源於每個人的習慣。魔兔網絡科技真誠希望能有那樣一天——魔兔網絡科技不必再用處罰去約束玩家的行為。<br>" +
    "若您違反本協議的規定，除了根據其他條款規定受到相應處罰外，還可能會遭受以下一項或幾項懲罰:<br>" +
    "(1)警告：警告僅僅是針對違反遊戲規則的玩家做出的教育導向，它是用於正常管理遊戲運行的一種方式。<br>" +
    "(2)禁言：關閉違規玩家的部分或全部聊天頻道，強制暫停玩家用戶帳號的線上對話功能，使玩家用戶帳號無法與其他玩家對話，直到此次處罰到期或是取消。<br>" +
    "(3)暫時凍結玩法：將違規玩家的遊戲角色進行限制，限制其局部遊戲操作，直到此次處罰到期或是取消。<br>" +
    "(4)永久凍結玩法：將違規玩家的遊戲角色進行限制，限制其局部遊戲操作，且永久不予以解除或釋放。<br>" +
    "(5)暫時禁止登錄：違規玩家的用戶帳號將在一定的時間內暫時無法登錄使用魔兔網絡科技提供的某個或者某幾個遊戲，直到此次處罰到期或是取消。<br>" +
    "(6)永久禁止登錄：違規玩家的用戶帳號將永久無法登錄使用魔兔網絡科技服務。<br>" +
    "(7)強制離線：強制讓違規玩家離開當前遊戲，結束玩家當前遊戲程序的執行。<br>" +
    "(8)封停賬號：暫停或永久停止違規玩家遊戲帳號登錄魔兔網絡科技服務的權利。<br>" +
    "(9)刪除檔案：將違規玩家在遊戲世界中的人物檔案刪除，不讓該人物再出現在遊戲世界。<br>" +
    "(10)承擔法律責任：玩家的不當行為對他人或者魔兔網絡科技造成損害或者與現行法律規定相違背的，違規玩家要依法承擔相應的民事、行政或刑事責任。<br>" +
    "(11)解散組織：解散玩家成立的包括但不限於幫派、工會、勢力組織。<br>" +
    "(12)修改暱稱：對於玩家包括但不限於人物暱稱可以由玩家自主命名的暱稱或名稱進行強制修改。<br>" +
    "(13)暫時限制遊戲行為：違規玩家的用戶帳號將在一定的時間內被限制使用部分遊戲服務。<br>" +
    "(14)撤銷交易：撤銷違規交易、將交易雙方付出的遊戲虛擬物品予以還原。<br>" +
    "(15)扣除違規交易所得：扣除違規交易中，違規一方或違規雙方所獲得的遊戲虛擬物品或虛擬貨幣。<br>" +
    "(16)交易功能限制：暫時凍結違規交易中，違規一方或違規雙方所獲得的遊戲虛擬物品或虛擬貨幣，並持續考察其在指定期限內的遊戲內行為。如指定期限內其無再次違規的，到期自動解凍相應的遊戲虛擬物品；如指定期限內其再次違規的，在魔兔網絡科技認定其違規行為存在時扣除其被凍結的遊戲虛擬物品。<br>" +
    "(17)凍結遊戲虛擬物品：對違規玩家限定其遊戲角色的遊戲虛擬物品的相關功能，包括但不限於物品的使用、交易、給予。<br>" +
    "(18)收回游戲虛擬物品：對於玩家因欺詐或其他違規行為而獲取的遊戲虛擬物品，包括但不限於遊戲虛擬物品進行收回。<br>" +
    "(19)其他處罰措施：包括但不限於沒收不正當利益（如玩家通過不正當途徑獲得的遊戲虛擬物品）、倒扣數值（包括但不限於經驗值）、刪除論壇帖子、屏蔽論壇賬號、暫時中斷服務。<br>" +
    "第十五條遊戲內反騷擾處理規則<br>" +
    "魔兔網絡科技倡議玩家對自己的言行負責，文明遊戲，健康遊戲，若玩家出現本條約定的以下情形，將會被按照本條的規定進行處罰。<br>" +
    "1、冒充系統：在遊戲中，凡是通過各種方式、行為冒充系統向其他玩家散佈或傳播虛假信息，根據情況將有可能受到以下處罰：警告；禁言；暫時凍結玩法；永久凍結玩法；暫時禁止登錄；永久禁止登錄。<br>" +
    "2、非法網站：為了維護遊戲世界中的潔淨與和諧，凡是宣揚非法網站的，根據情況將有可能受到以下處罰：警告；禁言；暫時凍結玩法；永久凍結玩法；暫時禁止登錄；永久禁止登錄。<br>" +
    "3、言行不雅：在遊戲中，凡是通過各種方式、行為散佈或傳播言行不雅的信息，根據情況將有可能受到以下處罰：警告；禁言；暫時凍結玩法；永久凍結玩法；強制離線；暫時禁止登錄。<br>" +
    "4、垃圾廣告信息：大量傳播相同的、類似短語或無實質意義內容的言行，以及任何與所在遊戲無關的信息(包括但不限於刷屏)，或者發布、傳播任何貶損、詆毀、惡意攻擊所在遊戲或魔兔網絡科技的信息或者其他不實信息，根據情況將有可能受到以下處罰：警告；禁言；暫時凍結玩法；永久凍結玩法；強制離線；暫時禁止登錄；永久禁止登錄。<br>" +
    "5、地區分裂：在遊戲中，凡是通過各種方式或途徑引起地區紛爭的行為，根據情況將有可能受到以下處罰：警告；禁言；暫時凍結玩法；永久凍結玩法；強制離線；暫時禁止登錄；永久禁止登錄。<br>" +
    "6、違禁藥品或行為：在遊戲中，凡是涉及違禁藥品的行為，根據情況將有可能受到以下處罰：警告；禁言；暫時凍結玩法；永久凍結玩法；強制離線；暫時禁止登錄；永久禁止登錄。<br>" +
    "7、現實生活信息和人身恐嚇：凡是涉及任何與遊戲世界無直接關係的暴力行為，以及洩漏其它玩家或魔兔網絡科技員工的任何遊戲世界和現實生活信息，根據情況將有可能受到以下處罰：禁言；強制離線；暫時凍結玩法；永久凍結玩法；暫時禁止登錄；永久禁止登錄；承擔法律責任。<br>" +
    "8、宣傳或使用木馬、外掛、病毒信息：在遊戲中，凡是通過各種方式、行為散佈或傳播、使用木馬、外掛、病毒信息，根據情況將有可能受到以下處罰：禁言；暫時凍結玩法；永久凍結玩法；暫時禁止登錄；永久禁止登錄；強制離線；封停賬號；刪除檔案；承擔法律責任。<br>" +
    "9、宣傳代練：在遊戲中，凡是通過各種方式、行為散佈或傳播代練的信息，根據情況將有可能受到以下處罰：禁言；暫時凍結玩法；永久凍結玩法；暫時禁止登錄；永久禁止登錄；強制離線；封停賬號；刪除檔案。<br>" +
    "10、宣傳或進行線下交易：用戶只可在遊戲內或者通過魔兔網絡科技認可的交易平台（如有）進行遊戲虛擬物品交易。對於用戶在任何非魔兔網絡科技事先認可的充值平台或其他交易平台進行充值或進行其他交易的相關行為（包括但不限於用戶通過第三方進行充值或遊戲內虛擬物品的購買），魔兔網絡科技將予以嚴厲打擊和處罰。一經查證屬實，魔兔網絡科技有權視具體情況採取各種處理措施，包括如下一項或幾項：警告、倒扣數值、凍結或回收遊戲虛擬物品、暫時凍結玩法、永久凍結玩法、強制離線、封停賬號、刪除檔案及採取其他技術措施防止用戶從事該行為；情節嚴重的，魔兔網絡科技保留追究用戶法律責任的權利。<br>" +
    "11、宣傳或發布違法信息，嚴重違反社會公德：在遊戲中，凡是涉及違反國家法律、違背社會道德文明準則的言語或行為，包括但不限於宣傳或參與賭博、宣傳邪教行為，玩家將受到以下處罰：警告；禁言；強制離線；暫時凍結玩法；永久凍結玩法；暫時禁止登錄；永久禁止登錄；刪除檔案；承擔法律責任。<br>" +
    "12、其他騷擾行為：除本條上述情形外，若玩家出現其他不符合法律法規、社會公德或遊戲規則的騷擾情形，根據情況將可能受到以下處罰：警告；禁言；暫時凍結玩法；永久凍結玩法；暫時禁止登錄；永久禁止登錄；強制離線；封停賬號；刪除檔案；承擔法律責任。<br>" +
    "第十六條遊戲管理員(以下簡稱“GM”)交互管理規則<br>" +
    "1、在遊戲過程中，玩家可能會因為種種原因與GM進行交流。魔兔網絡科技將就具體遊戲提供官方的遊戲論壇作為玩家和GM之間的交流平台。如果在遊戲中遇到問題，玩家可以通過官方論壇提交問題，它將給玩家提供快速、優質的服務。<br>" +
    "2、希望GM與玩家的交流能對玩家有所幫助，但請玩家遵守相關規定。魔兔網絡科技將嚴肅處理以下行為：<br>" +
    "(1)冒充系統或GM：在遊戲中，可能會存在某些玩家冒充系統或GM的行為。如若發現，您可以通過遊戲論壇向GM舉報，並協助查證。一經查實，魔兔網絡科技將對其採取嚴厲的處罰措施。<br>" +
    "(2)欺騙或試圖欺騙GM：在遊戲中，玩家不要試圖利用魔兔網絡科技對您的信任，做出某些欺騙或試圖欺騙GM的行為。如若發現，魔兔網絡科技將對該玩家採取嚴厲的處罰措施。試圖欺騙GM的行為包括但不限於誤導GM、拒絕提供信息、提供虛假信息以及任何試圖“詐騙”GM的行為。<br>" +
    "(3)違反或忽視GM做出的提示：在遊戲中，為了確保大多數玩家的共同利益，維護正常的遊戲秩序，GM可能會提示玩家執行某些操作或停止執行某些操作，任何忽視或阻撓該項工作的行為都可能導致玩家遊戲人物受到處罰。因此，玩家應當保持合作態度。<br>" +
    "(4)干擾GM工作：在遊戲中，如若出現以下行為，魔兔網絡科技將對其採取嚴厲的處罰措施：<br>" +
    "① 向GM索取任何虛擬遊戲物品（包括但不限於遊戲資源、裝備）；<br>" +
    "② 頻繁呼叫GM或發送無實質性內容的請求；<br>" +
    "③ 反復向GM發送已解答或解決問題的幫助請求。<br>" +
    "(5)辱罵或惡意攻擊GM：在遊戲中，不允許出現辱罵或惡意攻擊GM的言行。如若發現，魔兔網絡科技將對其採取嚴厲的處罰措施。<br>" +
    "(6)擾亂遊戲秩序<br>" +
    "第十七條命名管理規則<br>" +
    "雖然人物暱稱、玩家所建立的組織名稱可以由玩家來命名，但是為了維護遊戲世界中的潔淨與和諧，魔兔網絡科技不允許出現包括但不限於涉及種族/宗教、國家政治、國家領導人、淫穢的/粗俗的、誹謗/恐嚇、宗教或宗教人物、工作人員、攻擊性的、污辱性的、可能引起誤會的、違禁藥品內容的名稱。<br>" +
    "如若發現前述情形，違規玩家根據情況將有可能受到以下處罰：警告；禁言；暫時凍結玩法；永久凍結玩法；強制離線；暫時禁止登錄；永久禁止登錄；修改暱稱；解散組織。<br>" +
    "第十八條利用遊戲Bug以及第三方軟件處理規則<br>" +
    "1、遊戲BUG指遊戲系統、程序、設定方面存在的漏洞或不合理的現象。<br>" +
    "玩家有義務向GM報告在遊戲中出現的BUG。嚴禁玩家直接或間接利用遊戲BUG、程序漏洞獲利或擾亂遊戲秩序，或者利用BUG、漏洞以達到個人目的。如果玩家有該行為，一經查實，可能受到如下處罰措施：沒收玩家利用BUG進行遊戲而直接、間接獲得之不正當利益；倒扣數值（包括但不限於經驗值）；撤銷交易；扣除違規交易所得；交易功能限制；強制離線；暫時凍結玩法；永久凍結玩法；暫時禁止登錄；永久禁止登錄；刪除檔案；承擔法律責任。<br>" +
    "2、未經許可的第三方軟件指可用於在遊戲中獲取優勢，但不屬於相應魔兔網絡科技軟件一部分的任何文件或程序，包括作弊性質的外掛以及相關輔助性質的外掛（包括但不限於自動升級、自動練級、自動吃藥、自動完成任務、加速性質、模擬加點、戰鬥顯血或其他超出遊戲設定範圍的操作）。如若發現使用作弊性質的外掛以及相關輔助性質的外掛，我們將對其採取嚴厲的處罰措施，包括：沒收玩家利用第三方軟件進行遊戲而直接、間接獲得之不正當利益；倒扣數值（包括但不限於經驗值）；撤銷交易；扣除違規交易所得；交易功能限制；暫時凍結玩法；永久凍結玩法；強制離線；暫時禁止登錄；永久禁止登錄；刪除檔案；承擔法律責任。<br>" +
    "任何與魔兔網絡科技軟件同時使用的外部第三方軟件可能會對遊戲產生不良的影響。使用外部應用程序可能造成的主要後果是數據傳送不流暢，導致玩家頻繁掉線或卡機。外部應用軟件可能使玩家移動智能設備（包括但不限於手機、平板電腦）、電腦感染病毒、間諜軟件和其他不明程序的侵擾。第三方軟件還可能竊取玩家存儲在移動智能設備（包括但不限於手機、平板電腦）、電腦中的信息，賬號、密碼個人信息。<br>" +
    "第十九條盜號與盜號相關行為處理規則<br>" +
    "為保障玩家能愉悅的體驗遊戲，保障玩家的正當利益不受到侵害，魔兔網絡科技對盜號及盜號相關行為（包括但不限於盜取用戶帳號、遊戲數據、玩家個人資料、協助盜號者操作及轉移遊戲虛擬物品行為）將予以嚴厲打擊和處罰。一經查證屬實或應有權機關的要求，魔兔網絡科技有權視具體情況立即採取暫時限制遊戲行為、收回游戲虛擬物品、暫時禁止登錄、永久禁止登錄、封停賬號、刪除檔案處罰措施，情節嚴重的，魔兔網絡科技保留對涉案玩家追究法律責任的權利。<br>" +
    "儘管您未主動參與盜號，但如您獲得的遊戲虛擬物品是他人通過盜號方式獲得，而後轉移或者分配給您的，為了維護被盜玩家的權益及遊戲中公平公正的遊戲秩序，魔兔網絡科技有權收回您購買的該遊戲虛擬物品。<br>" +
    "在查證玩家被盜事件的過程中，為能夠快速調查、處理問題，魔兔網絡科技可能會請相關玩家協助調查，其方式包括但不限於禁止登錄調查、線上交流、線下交流。<br>" +
    "第二十條遊戲內欺詐行為處理規則<br>" +
    "誠實信用是遊戲中的基本原則。遊戲中的欺詐行為是指以非法佔有為目的，通過虛假承諾、虛構事實、隱瞞真相、故意誤導、冒充他人、故意混淆方式，騙取他人的遊戲虛擬物品或其它財物。遊戲內的欺詐行為包括暱稱相似欺詐、冒充好友、冒充官方及其他形式。<br>" +
    "如玩家在遊戲內進行欺詐，我們將根據玩家欺詐情節，採取各種處理措施，包括如下一項或幾項：收回游戲虛擬物品；倒扣數值（包括但不限於經驗值）；暫時凍結玩法；永久凍結玩法；強制離線；暫時禁止登錄；永久禁止登錄。<br>" +
    "儘管您未主動參與欺詐，但如您獲得的遊戲虛擬物品是他人通過欺詐方式獲得，而後轉移或者分配給您的，為了維護被盜玩家的權益及遊戲中公平公正的遊戲秩序，魔兔網絡科技有權收回您購買的該遊戲虛擬物品。<br>" +
    "第二十一條與充值相關的不誠信行為處理規則<br>" +
    "誠實信用也是用戶在充值相關行為中應遵循的基本原則。用戶成功為魔兔網絡科技服務充值獲得虛擬物品使用權或增值服務（以下統稱“充值收益”）後，如對魔兔網絡科技服務有任何誤會、不滿意、建議或其他訴求的，可隨時通過客服專區或客服電話通知魔兔網絡科技。用戶未選擇該方式而是另行進行退款操作的，應立即通過客服專區或客服電話通知魔兔網絡科技扣除相應的充值收益；如用戶進行退款操作後仍佔有充值服務的屬不誠信行為，魔兔網絡科技將予以嚴厲打擊和處罰，包括但不限於如下一項或幾項：警告、倒扣數值、凍結或回收遊戲虛擬物品、暫時凍結玩法、永久凍結玩法、強制離線、封停賬號、刪除檔案及採取其他技術措施防止用戶從事該行為；情節嚴重的，魔兔網絡科技保留追究用戶法律責任（包括但不限於民事責任、刑事責任）的權利。<br>" +
    "第二十二條數據異常處理規則<br>" +
    "如果魔兔網絡科技發現用戶數據異常或者存在違法或者其他不正當行為，“其他不正當行為”包括但不限於：（1）利用bug或非正常遊戲方式提升遊戲角色數據、遊戲內的角色排名的行為；（2）不以正常的遊戲娛樂互動需要為目的進行交易；（3）以轉移遊戲虛擬物品或提升特定遊戲角色實力為目的的非正常交易行為，包括但不限於購買並非自身遊戲角色遊戲所需的遊戲虛擬物品、以不正常價格交易遊戲虛擬物品、以自己控制的多個遊戲賬號互相交易遊戲虛擬物品。魔兔網絡科技有權進行調查並採取相應措施，包括但不限於：(1)刪除遊戲虛擬物品；(2)沒收不正當利益；(3)數據回退或清零；（4）禁言； (5)暫時禁止登錄；(6)永久禁止登錄；（7）暫時隔離；（8）永久隔離；(9)強制離線；（10)撤銷交易；(11)扣除違規交易所得；(12)交易功能限制；(13)封停直至刪除用戶帳號。用戶無權因此要求魔兔網絡科技承擔任何責任。<br>" +
    "第二十三條牟取不正當利益行為處理規則<br>" +
    "用戶理解並同意，魔兔網絡科技向用戶提供魔兔網絡科技服務，是為了讓用戶體驗豐富多彩的遊戲內容，而非利用魔兔網絡科技服務賺取現實世界的金錢或牟取經濟利益。而用戶不以體驗遊戲內容為目的，在遊戲中主要進行交易和牟利的行為，會破壞遊戲內經濟系統的公平性或平衡性，從而對其他用戶的遊戲體驗、遊戲本身造成不利影響。<br>" +
    "因此，用戶承諾不以營利為目的從事遊戲行為或交易虛擬物品，任何以營利為目的從事遊戲行為或交易虛擬物品的情形將被視為牟取不正當利益，包括但不限於用戶：<br>" +
    "(1)註冊多個用戶帳號和/或遊戲角色ID，以營利為目的進行遊戲行為；<br>" +
    "(2)從事遊戲內單一或系列產出玩法，將獲得的虛擬物品出售獲利；<br>" +
    "(3)利用不同服務器的虛擬物品價值差異，在不同服務器買賣虛擬物品獲利；<br>" +
    "(4)充當遊戲帳號、虛擬物品交易中介收取費用獲利；<br>" +
    "(5)在非魔兔網絡科技提供或認可的交易平台上交易用戶帳號或虛擬物品獲利；<br>" +
    "(6)將游戲內獲得的虛擬物品用於出售獲利而不注重本身角色實力的提升，角色多個技能、修煉、裝備、寵物水平與角色級相差較大的；<br>" +
    "(7)利用遊戲行為和遊戲內容組織或參與賭博、實施或參與實施盜竊他人財產或虛擬物品涉嫌違法犯罪行為的；<br>" +
    "(8)其他任何不以正常的遊戲娛樂互動需要為目的的遊戲內牟利行為。<br>" +
    "魔兔網絡科技有權對牟取不正當利益的用戶同時採取以下措施：對所有參與牟取不正當利益的用戶帳號（包括但不限於獲得、轉移、出售遊戲虛擬物品的賬號）進行倒扣數值、收回遊戲虛擬物品、暫時凍結玩法、永久凍結玩法、強制離線、暫時隔離、永久隔離、封停帳號、撤銷交易、扣除違規交易所得、交易功能限制、刪除檔案及採取其他技術措施防止用戶從事該行為；情節嚴重的，魔兔網絡科技保留追究用戶法律責任的權利。<br>" +
    "第二十四條角色保護規則<br>" +
    "若您報告角色被盜、遭遇黑客行為或出現其他異常情況，或者魔兔網絡科技發現您的角色存在被盜、共享或者被濫用跡像或者其他異常情況，為避免您的遊戲角色、遊戲虛擬物品遭受不法侵害，魔兔網絡科技將會對您的角色進行調查，並根據情節，在調查期間對您的角色採取保護性措施（包括但不限於暫時凍結角色）。請您根據魔兔網絡科技的指引，提交相關材料以配合魔兔網絡科技的調查，以便盡快解除您角色的保護性措施。<br>" +
    "第二十五條損害賠償<br>" +
    "如您在遊戲內的違規行為給魔兔網絡科技或第三方造成損害的，您應承擔相應的法律責任，而且針對自身的損害魔兔網絡科技有權採取一切合理的行動，包括但不限於收回遊戲虛擬物品，魔兔網絡科技並有權向您索回損失額並要求您承擔魔兔網絡科技合理的追索費用。<br>" +
    "第二十六條不可抗力<br>" +
    "魔兔網絡科技對不可抗力導致的損失不承擔責任。本協議所稱不可抗力包括：天災、法律法規或政府指令的變更，因網絡服務特性而特有的原因，境內外基礎電信運營商的故障、計算機、移動設備或互聯網相關技術缺陷、互聯網覆蓋範圍限制、計算機、移動設備病毒、黑客攻擊因素，及其他合法範圍內的不能預見、不能避免並不能克服的客觀情況。<br>" +
    "第二十七條鏈接及廣告信息<br>" +
    "魔兔網絡科技在遊戲官方網站、遊戲官方論壇、遊戲中所提供的所有鏈接，可能鏈接到其他個人、公司或組織的網站，提供該網站的目的，是便利用戶自行搜索或取得相關信息，魔兔網絡科技對於被鏈接的個人、公司或組織的網站所提供的產品、服務或信息，不擔保其真實性、完整性、實時性或可信度。這些個人、公司或組織與魔兔網絡科技間不存在任何僱傭、委任、代理、合夥或其他類似的關係。<br>" +
    "魔兔網絡科技在遊戲官方網站、遊戲官方論壇、遊戲內可能刊登商業廣告或其他推廣活動信息。這些廣告或推廣活動信息是由廣告商或商業服務提供者提供，並承擔相應責任，魔兔網絡科技僅提供刊登內容的媒介。用戶通過該鏈接的網站或廣告所購買的商品或服務，其交易行為僅存在於用戶與該商品或服務的提供者之間，與魔兔網絡科技無關，魔兔網絡科技不就用戶與該商品或服務的提供者之間所產生的交易行為承擔任何法律責任，用戶應予以特別留意。<br>" +
    "第二十八條信息的儲存和安全及服務的限制<br>" +
    "魔兔網絡科技對本協議下所提供的服務將盡力維護其安全性及方便性，但對服務中出現的信息（包括但不限於用戶發布的信息）刪除或儲存失敗不承擔任何責任。魔兔網絡科技保留判定用戶的行為是否符合本協議約定的權利，如果用戶違背了本協議的約定，魔兔網絡科技有權中斷依據本協議對用戶提供的服務。<br>" +
    "第二十九條條款變更<br>" +
    "魔兔網絡科技有權在必要的時候修改本協議條款，敬請用戶定期查詢有關內容。用戶如繼續使用本協議涉及的服務，則視為對修改內容的同意；用戶在不同意修改內容的情況下，應當卸載魔兔網絡科技軟件、終止本協議並停止使用魔兔網絡科技服務。<br>" +
    "第三十條遊戲數據<br>" +
    "在用戶參加遊戲過程中產生並儲存於魔兔網絡科技服務器中的任何數據信息，包括但不限於賬號數據信息、角色數據信息、級及虛擬物品數據信息（但用戶的姓名、身份證號、電話號碼個人身份數據信息除外），屬於遊戲軟件的一部分，由魔兔網絡科技所有並進行管理，用戶有權在遵守遊戲規則的前提下通過正當的途徑對屬於自身用戶帳號的數據信息進行修改、轉移、拋棄。<br>" +
    "第三十一條通知<br>" +
    "魔兔網絡科技所有發給用戶的通知可通過遊戲內、遊戲官方網站或遊戲官方論壇重要頁面的公告、電子郵件或常規的電話、易信、信件形式傳送。同時，用戶在此同意魔兔網絡科技可以向其電子郵箱、電話、易信、信件發送商業信息。<br>" +
    "第三十二條用戶所提供內容的知識產權及授權<br>" +
    "魔兔網絡科技尊重知識產權並註重保護用戶享有的各項權利。在魔兔網絡科技服務中，您可能需要通過上傳、發佈各種方式向魔兔網絡科技提供內容。在此情況下，您仍然享有此內容的完整知識產權。<br>" +
    "您在此明確同意，您在提供前述內容的同時，不可撤銷地授予魔兔網絡科技及其關聯公司一項全球性的、永久的免費許可，允許魔兔網絡科技及其關聯公司使用、傳播、複製、修改、再許可、翻譯、出版、表演及展示此內容，以及使用此內容創作衍生作品。<br>" +
    "第三十三條其他約定<br>" +
    "本協議的訂立、履行、解釋及爭議的解決均適用中華人民共和國法律並排除其他一切衝突法的適用。本協議訂立於廈門市思明區。如雙方就本協議的內容或其執行發生任何爭議（包括但不限於合同或者其他財產性權益糾紛），雙方應友好協商解決；協商不成時，雙方同意交由廈門市思明區人民法院管轄並處理。<br>" +
    "為避免爭議，本協議涉及到的有關數據、有關技術方面的問題，用戶同意以魔兔網絡科技服務器所儲存的數據作為判斷標準。魔兔網絡科技保證該數據的真實性。<br>" +
    "本協議所有條款的標題僅為方便閱讀，本身並無實際涵義，不能作為本協議及相關條款涵義解釋的依據。<br>" +
    "如本協議中的任何條款因任何原因被判定為完全或部分無效或不具有執行力的，本協議的其他條款仍應有效並且有執行力。<br>" +
    "魔兔網絡科技不行使、未能及時行使或者未充分行使本協議或者按照法律規定所享有的權利，不應被視為放棄該權利，也不影響魔兔網絡科技在將來行使該權利。</div>";
  result += "<div><span class='small-title'>⊙重要提示</span> <br>" +
    "營造舒適、公平、富有人情味的遊戲環境是魔兔網絡科技的目的。魔兔網絡科技隨時敞開心扉接納不同地域、年齡和文化背景的玩家。在遊戲中，不論是魔兔網絡科技的工作人員，還是其他數以萬計的玩家，都在扮演不同的角色、行使各自的使命。魔兔網絡科技對尊重遊戲規則和尊重他人的玩家滿懷感激和敬意，讓我們攜手打造綠色網游，共同編織美好夢想！<br>" +
    "青少年用戶必須遵守全國青少年網絡文明公約：要善於網上學習，不瀏覽不良信息；要誠實友好交流，不侮辱欺詐他人；要增強自護意識，不隨意約會網友；要維護網絡安全，不破壞網絡秩序；要有益身心健康，不沉溺虛擬時空。</div>";
  return result;
}

export const agreement_en = () => {
  return "";
}

export const privacy_zh = () => {
  let result = "魔兔網絡科技隱私政策";
  result = "<div class='big-title'>魔兔网络科技用户协议</div>";
  result += "<div>本政策是由魔兔网络科技有限公司（以下称为“魔兔网络科技”）就魔兔网络科技在其和/或其关联公司的移动手机游戏平台上所提供的产品和服务（包括魔兔网络科技的网站以及魔兔网络科技现在正在提供和将来可能向用户提供的游戏服务和其他网络服务，以下统称为“产品和服务”）所制定的。 </div>";
  result += "<div>本政策将帮助您了解以下内容：<br>" +
    "一、我们如何收集和使用您的个人信息<br>" +
    "二、我们如何使用 Cookie 和同类技术<br>" +
    "三、我们如何共享、转让、公开披露您的个人信息<br>" +
    "四、我们如何保护您的个人信息<br>" +
    "五、您的权利<br>" +
    "六、我们如何处理未成年人的个人信息<br>" +
    "七、您的个人信息如何在全球范围转移<br>" +
    "八、本政策可能变更<br>" +
    "九、如何联系我们</div>";
  result += "<div>魔兔网络科技深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则。<br>" +
    "请注意，魔兔网络科技可能适时对本协议进行修改与更新，您同意将随时留意查看本协议的最新版本。请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》，以确保对本《隐私政策》的最新版本始终保持了解。<br>" +
    "一、我们如何收集和使用您的个人信息<br>" +
    "个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。魔兔网络科技基于本政策所述的以下目的，收集和使用您的个人信息。如需超过以下目的使用您的信息，魔兔网络科技将另行征得您的同意：<br>" +
    "（一）为您提供魔兔网络科技在其和/或其关联公司的手机游戏平台上所提供的产品和服务<br>" +
    "1、注册成为用户。<br>" +
    "为完成创建账号所填写的信息。包括您的手机号码、身份证、创建的用户名。<br>" +
    "2、为您提供您可能感兴趣的广告、资讯及产品信息<br>" +
    "为向您提供与您更加相关的广告以替代普遍投放的广告 ，我们可能会收集和使用您在魔兔网络科技的操作记录和部分必要的设备信息（即您的唯一设备识别码），以及您在使用我们服务时浏览或要求提供的其他信息和内容详情、游戏账号交易信息，提取您的浏览、行为习惯特征，并基于特征标签通过短信或其他方式向与您具备相同或相似标签的用户群体发送营销信息，提供或推广我们的产品及服务。<br>" +
    "3、支付结算。<br>" +
    "为便于您在支付相关订单时，综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，我们可能会在交易过程中收集您的虚拟财产相关信息（仅限交易记录、虚拟货币、虚拟交易、游戏类兑换码）。<br>" +
    "4、安全保障<br>" +
    "我们会将您的部分个人常用设备信息用于身份验证、安全防范、诈骗监测、存档备份用途。唯一设备码用于安全防范、用户标识，个人上网记录用于安全防范、诈骗监测。<br>" +
    "当您使用我们的客户服务时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。<br>" +
    "5、产品开发和服务优化。<br>" +
    "为修复系统故障并优化我们的服务，我们可能需记录和分析系统故障时产生的信息。<br>" +
    "二、我们如何使用 Cookie 和同类技术<br>" +
    "（一）Cookie<br>" +
    "为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。 Cookie有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信息了解您使用服务进行什么活动、或哪些服务或服务最受欢迎；及有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。<br>" +
    "我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好通过浏览器或其他方式设置管理或删除 Cookie。<br>" +
    "（二）Do Not Track（请勿追踪）<br>" +
    "很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布 Do Not Track 请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了 Do Not Track，那么我们的所有网站都会尊重您的选择。但请您注意，可能因此影响您使用魔兔网络科技提供产品及服务的体验。<br>" +
    "三、我们如何共享、转让、公开披露您的个人信息<br>" +
    "（一）共享<br>" +
    "您理解并同意，经过去标识化处理后的信息将无法识别您的身份，在此情况下我们将已经去标识化的信息用于本隐私政策之目的，并在确保数据接收方无法重新识别个人信息主体的前提下，通过共享、转让的方式提供给第三方。我们可能在以下情况下与魔兔网络科技以外的任何公司、组织和个人分享您的个人信息：<br>" +
    "1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。<br>" +
    "2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。<br>" +
    "3、与我们的关联公司共享：您的个人信息可能会与魔兔网络科技的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。<br>" +
    "4、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。<br>" +
    "（二）转让<br>" +
    "我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br>" +
    "1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；<br>" +
    "2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们将通过推送通知、公告或其他方式另行告知您相关情形，按照法律法规所要求的标准继续保护或要求新的管理者按照本政策继续保护您的个人信息。<br>" +
    "3、部分场景下，您可以使用相同的账号及密码在其他第三方平台登录、使用，以获得更好的游戏体验。为提供此项服务，我们可能需要向第三方传送您的个人信息及游戏信息，我们将按照法律法规所要求的标准继续保护或要求新的管理者按照本政策继续保护您的个人信息。<br>" +
    "（三）公开披露<br>" +
    "我们仅会在以下情况下，公开披露您的个人信息：<br>" +
    "1、获得您明确同意后；<br>" +
    "2、与国家安全、国防安全有关的；<br>" +
    "3、与公共安全、公共卫生、重大公共利益有关的；<br>" +
    "4、与犯罪侦查、起诉、审判和判决执行有关的；<br>" +
    "5、出于维护信息主体或其他个人的生命、财产重大合法权益但又很难得到您本人同意的；<br>" +
    "6、所收集的信息是您自行向社会公众公开的；<br>" +
    "7、从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开渠道；<br>" +
    "8、根据您的要求签订合同所必需的；<br>" +
    "9、用于维护魔兔网络科技服务的安全稳定运行所必需的<br>" +
    "10、为合法的新闻报道所必需的；<br>" +
    "11、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；<br>" +
    "12、法律法规规定的其他情形。<br>" +
    "四、我们如何保护您的个人信息<br>" +
    "（一）我们会采取一切合理可行的措施，保护您的个人信息。我们使用SSL/hash对您的数据进行加密保护；如我们与第三方分享您的信息，我们将会采用加密、脱敏及其他去标识化处理手段保障您的信息安全。<br>" +
    "（二）我们为保护信息采取的其他安全措施<br>" +
    "我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范信息的存储和使用。<br>" +
    "我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。<br>" +
    "（三）我们仅允许有必要知晓这些信息的魔兔网络科技工作人员、合作伙伴访问您的信息，同时要求可能接触到您的信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与魔兔网络科技的合作关系。<br>" +
    "（四）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在必要的合理期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。<br>" +
    "（五）互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他魔兔网络科技用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。<br>" +
    "（六）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。<br>" +
    "（七）在不幸发生个人信息安全事件后，我们将采取必要措施以阻止安全事件扩大，并以推送通知、官网公告形式告知您。<br>" +
    "五、您的权利<br>" +
    "按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：<br>" +
    "（一）访问您的个人信息<br>" +
    "您有权访问您的个人信息，法律法规规定的例外情况除外。<br>" +
    "（二）控制您的个人信息<br>" +
    "您可随时查询并管理您账户下的个人信息，帐号名称是您重要的网络身份标识，出于安全性和身份识别的考虑，在注册之后无法变更。<br>" +
    "（三）删除您的个人信息<br>" +
    "我们将按照本政策所述，仅为实现我们产品或服务的功能，收集、使用您的信息。如您发现我们违反法律、行政法规的规定或者双方的约定收集、使用您的个人信息，您可以要求我们删除。如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。请通过本政策列明的联系方式与我们联系。<br>" +
    "（四）改变您授权同意的范围<br>" +
    "每个业务功能需要一些基本的个人信息才能得以完成（见本政策第一款）。您可以在使用我们服务的过程中，访问、修改和删除您提供的注册信息和其他个人信息。您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。若您在使用地理位置相关服务时，希望停止分享您的地理位置信息，您可通过手机定位关闭功能、软硬件服务商及通讯服务提供商的关闭方式停止分享。<br>" +
    "（五）响应您的上述请求<br>" +
    "为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在合理时限内做出答复。如您不满意，可以联系魔兔网络科技客服或依《用户注册服务协议》约定方式处理。<br>" +
    "对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。<br>" +
    "在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br>" +
    "1、与国家安全、国防安全直接相关的；<br>" +
    "2、与公共安全、公共卫生、重大公共利益直接相关的；<br>" +
    "3、与犯罪侦查、起诉、审判和判决执行直接相关的；<br>" +
    "4、有充分证据表明您存在主观恶意或滥用权利的；<br>" +
    "5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br>" +
    "6、涉及商业秘密的；<br>" +
    "7、其他我们有合理理由拒绝的情形。<br>" +
    "六、我们如何处理未成年人的个人信息<br>" +
    "我们的产品、网站和服务主要面向成人。魔兔网络科技遵从国家政策，如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。对于经父母或监护人同意而收集未成年人个人信息的情况，我们只会在受到法律的允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。<br>" +
    "七、您的个人信息如何在全球范围转移<br>" +
    "原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。<br>" +
    "我们可能通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。<br>" +
    "境外管辖区可能有不同的个人信息保护法，我们将对信息进行加密传输，并尽商业上合理努力督促第三方在使用您的个人信息时遵守其适用的法律法规及协议约定的保密和安全措施。<br>" +
    "八、本政策可能变更<br>" +
    "未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。<br>" +
    "对于重大变更，我们还会提供更为显著的通知，如您不同意变更后的内容，您可以选择停止使用我们的服务；如您仍然继续使用我们服务的，即表示同意受经修订的本《隐私政策》的约束。";
  return result;
}

export const privacy_tw = () => {
  let result = "";
  result = "<div class='big-title'>魔兔網絡科技隱私政策</div>";
  result += "<div>本政策是由魔兔網絡科技有限公司（以下稱為“魔兔網絡科技”）就魔兔網絡科技在其和/或其關聯公司的移動手機遊戲平台上所提供的產品和服務（包括魔兔網絡科技的網站以及魔兔網絡科技現在正在提供和將來可能向用戶提供的遊戲服務和其他網絡服務，以下統稱為“產品和服務”）所製定的。</div>";
  result += "本政策將幫助您了解以下內容：<br>" +
    "一、我們如何收集和使用您的個人信息<br>" +
    "二、我們如何使用Cookie 和同類技術<br>" +
    "三、我們如何共享、轉讓、公開披露您的個人信息<br>" +
    "四、我們如何保護您的個人信息<br>" +
    "五、您的權利<br>" +
    "六、我們如何處理未成年人的個人信息<br>" +
    "七、您的個人信息如何在全球範圍轉移<br>" +
    "八、本政策可能變更<br>" +
    "九、如何联系我們<br>" +
    " <br>" +
    "魔兔網絡科技深知個人信息對您的重要性，並會盡全力保護您的個人信息安全可靠。我們致力於維持您對我們的信任，恪守以下原則，保護您的個人信息：權責一致原則、目的明確原則、選擇同意原則、最少夠用原則、確保安全原則、主體參與原則、公開透明原則。<br>" +
    "請注意，魔兔網絡科技可能適時對本協議進行修改與更新，您同意將隨時留意查看本協議的最新版本。請在使用我們的產品（或服務）前，仔細閱讀並了解本《隱私政策》，以確保對本《隱私政策》的最新版本始終保持了解。<br>" +
    "一、我們如何收集和使用您的個人信息<br>" +
    "個人信息是指以電子或者其他方式記錄的能夠單獨或者與其他信息結合識別特定自然人身份或者反映特定自然人活動情況的各種信息。魔兔網絡科技基於本政策所述的以下目的，收集和使用您的個人信息。如需超過以下目的使用您的信息，魔兔網絡科技將另行徵得您的同意：<br>" +
    "（一）為您提供魔兔網絡科技在其和/或其關聯公司的手機遊戲平台上所提供的產品和服務<br>" +
    "1、註冊成為用戶。<br>" +
    "為完成創建賬號所填寫的信息。包括您的手機號碼、身份證、創建的用戶名。<br>" +
    "2、為您提供您可能感興趣的廣告、資訊及產品信息<br>" +
    "為向您提供與您更加相關的廣告以替代普遍投放的廣告，我們可能會收集和使用您在魔兔網絡科技的操作記錄和部分必要的設備信息（即您的唯一設備識別碼），以及您在使用我們服務時瀏覽或要求提供的其他信息和內容詳情、遊戲賬號交易信息，提取您的瀏覽、行為習慣特徵，並基於特徵標籤通過短信或其他方式向與您具備相同或相似標籤的用戶群體發送營銷信息，提供或推廣我們的產品及服務。<br>" +
    "3、支付結算。<br>" +
    "為便於您在支付相關訂單時，綜合判斷您賬戶及交易風險、進行身份驗證、檢測及防範安全事件，我們可能會在交易過程中收集您的虛擬財產相關信息（僅限交易記錄、虛擬貨幣、虛擬交易、遊戲類兌換碼）。<br>" +
    "4、安全保障<br>" +
    "我們會將您的部分個人常用設備信息用於身份驗證、安全防範、詐騙監測、存檔備份用途。唯一設備碼用於安全防範、用戶標識，個人上網記錄用於安全防範、詐騙監測。<br>" +
    "當您使用我們的客戶服務時，我們可能會保存您的通信/通話記錄和內容或您留下的聯繫方式信息，以便與您聯繫或幫助您解決問題，或記錄相關問題的處理方案及結果。<br>" +
    "5、產品開發和服務優化。<br>" +
    "為修復系統故障並優化我們的服務，我們可能需記錄和分析系統故障時產生的信息。<br>" +
    "二、我們如何使用Cookie 和同類技術<br>" +
    "（一）Cookie<br>" +
    "為確保網站正常運轉，我們會在您的計算機或移動設備上存儲名為Cookie 的小數據文件。Cookie 通常包含標識符、站點名稱以及一些號碼和字符。Cookie有助於我們辨認您作為我們的註冊用戶的身份，或保存您向我們提供有關您的喜好或其他信助於我們辨認您作為我們的註冊用戶的身份，或保存您向我們提供有關您的喜好或其他信息了解您使用服務進行什麼活動、或哪些服務或服務最受歡迎；及有助於我們根據您的信息，向您提供與您相關的廣告而非進行普遍的廣告投放。<br>" +
    "我們不會將Cookie 用於本政策所述目的之外的任何用途。您可根據自己的偏好通過瀏覽器或其他方式設置管理或刪除Cookie。<br>" +
    "（二）Do Not Track（請勿追踪）<br>" +
    "很多網絡瀏覽器均設有Do Not Track 功能，該功能可向網站發布Do Not Track 請求。目前，主要互聯網標準組織尚未設立相關政策來規定網站應如何應對此類請求。但如果您的瀏覽器啟用了Do Not Track，那麼我們的所有網站都會尊重您的選擇。但請您注意，可能因此影響您使用魔兔網絡科技提供產品及服務的體驗。<br>" +
    "三、我們如何共享、轉讓、公開披露您的個人信息<br>" +
    "（一）共享<br>" +
    "您理解並同意，經過去標識化處理後的信息將無法識別您的身份，在此情況下我們將已經去標識化的信息用於本隱私政策之目的，並在確保數據接收方無法重新識別個人信息主體的前提下，通過共享、轉讓的方式提供給第三方。我們可能在以下情況下與魔兔網絡科技以外的任何公司、組織和個人分享您的個人信息：<br>" +
    "1、在獲取明確同意的情況下共享：獲得您的明確同意後，我們會與其他方共享您的個人信息。<br>" +
    "2、我們可能會根據法律法規規定，或按政府主管部門的強制性要求，對外共享您的個人信息。<br>" +
    "3、與我們的關聯公司共享：您的個人信息可能會與魔兔網絡科技的關聯公司共享。我們只會共享必要的個人信息，且受本隱私政策中所聲明目的的約束。關聯公司如要改變個人信息的處理目的，將再次徵求您的授權同意。<br>" +
    "4、與授權合作夥伴共享：僅為實現本政策中聲明的目的，我們的某些服務將由授權合作夥伴提供。我們可能會與合作夥伴共享您的某些個人信息，以提供更好的客戶服務和用戶體驗。我們僅會出於合法、正當、必要、特定、明確的目的共享您的個人信息，並且只會共享提供服務所必要的個人信息。我們的合作夥伴無權將共享的個人信息用於任何其他用途。<br>" +
    "（二）轉讓<br>" +
    "我們不會將您的個人信息轉讓給任何公司、組織和個人，但以下情況除外：<br>" +
    "1、在獲取明確同意的情況下轉讓：獲得您的明確同意後，我們會向其他方轉讓您的個人信息；<br>" +
    "2、在涉及合併、收購或破產清算時，如涉及到個人信息轉讓，我們將通過推送通知、公告或其他方式另行告知您相關情形，按照法律法規所要求的標準繼續保護或要求新的管理者按照本政策繼續保護您的個人信息。<br>" +
    "3、部分場景下，您可以使用相同的賬號及密碼在其他第三方平台登錄、使用，以獲得更好的遊戲體驗。為提供此項服務，我們可能需要向第三方傳送您的個人信息及遊戲信息，我們將按照法律法規所要求的標準繼續保護或要求新的管理者按照本政策繼續保護您的個人信息。<br>" +
    "（三）公開披露<br>" +
    "我們僅會在以下情況下，公開披露您的個人信息：<br>" +
    "1、獲得您明確同意後；<br>" +
    "2、與國家安全、國防安全有關的；<br>" +
    "3、與公共安全、公共衛生、重大公共利益有關的；<br>" +
    "4、與犯罪偵查、起訴、審判和判決執行有關的；<br>" +
    "5、出於維護信息主體或其他個人的生命、財產重大合法權益但又很難得到您本人同意的；<br>" +
    "6、所收集的信息是您自行向社會公眾公開的；<br>" +
    "7、從合法公開披露的信息中收集信息的，如合法的新聞報導、政府信息公開渠道；<br>" +
    "8、根據您的要求籤訂合同所必需的；<br>" +
    "9、用於維護魔兔網絡科技服務的安全穩定運行所必需的<br>" +
    "10、為合法的新聞報導所必需的；<br>" +
    "11、學術研究機構基於公共利益開展統計或學術研究所必要，且對外提供學術研究或描述的結果時，對結果中所包含的信息進行去標識化處理的；<br>" +
    "12、法律法規規定的其他情形。<br>" +
    "四、我們如何保護您的個人信息<br>" +
    "（一）我們會採取一切合理可行的措施，保護您的個人信息。我們使用SSL/hash對您的數據進行加密保護；如我們與第三方分享您的信息，我們將會採用加密、脫敏及其他去標識化處理手段保障您的信息安全。<br>" +
    "（二）我們為保護信息採取的其他安全措施<br>" +
    "我們通過建立數據分類分級制度、數據安全管理規範、數據安全開發規範來管理規範信息的存儲和使用。<br>" +
    "我們通過信息接觸者保密協議、監控和審計機制來對數據進行全面安全控制。<br>" +
    "（三）我們僅允許有必要知曉這些信息的魔兔網絡科技工作人員、合作夥伴訪問您的信息，同時要求可能接觸到您的信息的所有人員履行相應的保密義務。如果未能履行這些義務，可能會被追究法律責任或被中止與魔兔網絡科技的合作關係。<br>" +
    "（四）我們會採取一切合理可行的措施，確保未收集無關的個人信息。我們只會在必要的合理期限內保留您的個人信息，除非需要延長保留期或受到法律的允許。<br>" +
    "（五）互聯網並非絕對安全的環境，而且電子郵件、即時通訊、及與其他魔兔網絡科技用戶的交流方式並未加密，我們強烈建議您不要通過此類方式發送個人信息。請使用複雜密碼，協助我們保證您的賬號安全。<br>" +
    "（六）互聯網環境並非百分之百安全，我們將盡力確保或擔保您發送給我們的任何信息的安全性。如果我們的物理、技術、或管理防護設施遭到破壞，導致信息被非授權訪問、公開披露、篡改、或毀壞，導致您的合法權益受損，我們將承擔相應的法律責任。<br>" +
    "（七）在不幸發生個人信息安全事件後，我們將採取必要措施以阻止安全事件擴大，並以推送通知、官網公告形式告知您。<br>" +
    "五、您的權利<br>" +
    "按照中國相關的法律、法規、標準，以及其他國家、地區的通行做法，我們保障您對自己的個人信息行使以下權利：<br>" +
    "（一）訪問您的個人信息<br>" +
    "您有權訪問您的個人信息，法律法規規定的例外情況除外。<br>" +
    "（二）控制您的個人信息<br>" +
    "您可隨時查詢並管理您賬戶下的個人信息，帳號名稱是您重要的網絡身份標識，出於安全性和身份識別的考慮，在註冊之後無法變更。<br>" +
    "（三）刪除您的個人信息<br>" +
    "我們將按照本政策所述，僅為實現我們產品或服務的功能，收集、使用您的信息。如您發現我們違反法律、行政法規的規定或者雙方的約定收集、使用您的個人信息，您可以要求我們刪除。如您發現我們收集、存儲的您的個人信息有錯誤的，您也可以要求我們更正。請通過本政策列明的聯繫方式與我們聯繫。<br>" +
    "（四）改變您授權同意的範圍<br>" +
    "每個業務功能需要一些基本的個人信息才能得以完成（見本政策第一款）。您可以在使用我們服務的過程中，訪問、修改和刪除您提供的註冊信息和其他個人信息。您訪問、修改和刪除個人信息的範圍和方式將取決於您使用的具體服務。若您在使用地理位置相關服務時，希望停止分享您的地理位置信息，您可通過手機定位關閉功能、軟硬件服務商及通訊服務提供商的關閉方式停止分享。<br>" +
    "（五）響應您的上述請求<br>" +
    "為保障安全，您可能需要提供書面請求，或以其他方式證明您的身份。我們可能會先要求您驗證自己的身份，然後再處理您的請求。我們將在合理時限內做出答复。如您不滿意，可以聯繫魔兔網絡科技客服或依《用戶註冊服務協議》約定方式處理。<br>" +
    "對於您合理的請求，我們原則上不收取費用，但對多次重複、超出合理​​限度的請求，我們將視情收取一定成本費用。對於那些無端重複、需要過多技術手段（需要開發新系統或從根本上改變現行慣例）、給他人合法權益帶來風險或者非常不切實際（涉及備份磁帶上存放的信息）的請求，我們可能會予以拒絕。<br>" +
    "在以下情形中，按照法律法規要求，我們將無法響應您的請求：<br>" +
    "1、與國家安全、國防安全直接相關的；<br>" +
    "2、與公共安全、公共衛生、重大公共利益直接相關的；<br>" +
    "3、與犯罪偵查、起訴、審判和判決執行直接相關的；<br>" +
    "4、有充分證據表明您存在主觀惡意或濫用權利的；<br>" +
    "5、響應您的請求將導致您或其他個人、組織的合法權益受到嚴重損害的；<br>" +
    "6、涉及商業秘密的；<br>" +
    "7、其他我們有合理理由拒絕的情形。<br>" +
    "六、我們如何處理未成年人的個人信息<br>" +
    "我們的產品、網站和服務主要面向成人。魔兔網絡科技遵從國家政策，如果沒有父母或監護人的同意，未成年人不得創建自己的用戶賬戶。對於經父母或監護人同意而收集未成年人個人信息的情況，我們只會在受到法律的允許、父母或監護人明確同意或者保護未成年人所必要的情況下使用或公開披露此信息。<br>" +
    "七、您的個人信息如何在全球範圍轉移<br>" +
    "原則上，我們在中華人民共和國境內收集和產生的個人信息，將存儲在中華人民共和國境內。<br>" +
    "我們可能通過遍布全球的資源和服務器提供產品或服務，這意味著，在獲得您的授權同意後，您的個人信息可能會被轉移到您使用產品或服務所在國家/地區的境外管轄區，或者受到來自這些管轄區的訪問。<br>" +
    "境外管轄區可能有不同的個人信息保護法，我們將對信息進行加密傳輸，並儘商業上合理努力督促第三方在使用您的個人信息時遵守其適用的法律法規及協議約定的保密和安全措施。<br>" +
    "八、本政策可能變更<br>" +
    "未經您明確同意，我們不會削減您按照本隱私政策所應享有的權利。我們會在本頁面上發布對本政策所做的任何變更。<br>" +
    "對於重大變更，我們還會提供更為顯著的通知，如您不同意變更後的內容，您可以選擇停止使用我們的服務；如您仍然繼續使用我們服務的，即表示同意受經修訂的本《隱私政策》的約束。</div>";
  return result;
}

export const privacy_en = () => {

}





// WEBPACK FOOTER //
// ./src/config/protocol.js